const translations = {
  en: {
    // Navigation
    services: "Services",
    ourWork: "Our Work",
    locations: "Locations",
    whoWeAre: "Who We Are",
    insights: "Insights",
    newsroom: "Newsroom",
    careers: "Careers",
    search: "Search",

    //Our HISTORY

    historyEvent1Title: "Humble Beginnings",
    historyEvent1Desc:
      "In 2015, the company was founded by a small team of visionaries determined to change the construction game through quality, reliability, and innovation.",
    historyEvent1Alt: "Construction site in early development",

    historyEvent2Title: "First Major Milestone",
    historyEvent2Desc:
      "By 2018, the company had completed its first large-scale commercial project, gaining trust across the region and expanding its operational reach.",
    historyEvent2Alt: "Completed commercial building",

    historyEvent3Title: "Breaking New Ground",
    historyEvent3Desc:
      "2022 marked a shift into modular and prefabricated construction. Investments in DfMA and lean building practices revolutionized the delivery process.",
    historyEvent3Alt: "Workers installing modular components on site",

    historyEvent4Title: "Innovation Meets Scale",
    historyEvent4Desc:
      "In 2024, the company scaled its modular services across Portugal, winning national contracts and partnering with public and private sector clients.",
    historyEvent4Alt: "Large modular building under assembly",

    historyEvent5Title: "Building the Future Today",
    historyEvent5Desc:
      "Today, the company leads in sustainable, modular construction—driven by purpose, powered by technology, and committed to community impact.",
    historyEvent5Alt: "Modern modular facility with solar panels",

    //Budget Cons Page
    buildingServices: "Building Services",
    constructabilityBudget: "Constructability and Budget Control",
    constructabilityBudgetDesc:
      "We deliver innovative solutions that optimize construction processes and reduce costs, ensuring projects are completed on time and within budget.",

    ownersSectionTitle: "EMPLOYEE OWNERSHIP",
    ownersSectionDesc: "Building Success Through Shared Ownership",
    employeeOwnership: "100% Employee-Owned",
    ownershipBenefits:
      "As employee-owners, we are personally invested in the success of every project and the satisfaction of every client.",
    ownershipCulture: "Ownership Culture",
    ownershipDesc:
      "Our ownership culture drives innovation, excellence, and a deep commitment to delivering exceptional results.",
    joinOurTeam: "JOIN OUR TEAM",
    // learnMore: "LEARN MORE",
    presidentPortrait: "President's Portrait",

    //Where We Work - Main Page
    workLocationTitle: "WHERE WE WORK",
    workLocationDesc: "Global Reach, Local Expertise",
    globalPresence:
      "With strategically located offices in Portugal, we deliver exceptional construction services across the country while maintaining strong local connections.",
    viewOffices: "VIEW OUR OFFICES",
    officesDescription: "Get to know the offices behind our projects",
    employeeOwnedStat: "Employee Ownership",
    activeProjectsStat: "Active Projects",

    prefabModularDesc:
      "As future-focused industry leaders, Golden M International has pioneered in modular construction – including full volumetric, partial volumetric and modular components – for over 30 years with modular facilities across Portugal.",

    // Services Dropdown
    buildings: "Buildings",
    civil: "Civil",
    industrial: "Industrial",
    servicesTitle: "SERVICES",
    constructabilityBudget: "Constructability and Budget Control",
    smartConstruction: "Smart Construction",
    prefabModular: "Prefabrication and Modular Construction",
    sustainableConstruction: "Sustainable Construction Services",
    constructionServices: "Construction Services",
    emergencyResponse: "Emergency Response",
    selfPerform: "Self-Perform Capabilities",
    deliveryMethods: "Delivery Methods",
    preconstructionServices: "Preconstruction Services",
    specialProjects: "Special Projects",

    // PreFab Page
    prefabModular: "Prefabrication and Modular Construction",
    prefabModularDesc:
      "As future-focused industry leaders, Golden M International has pioneered in modular construction – including full volumetric, partial volumetric and modular components – for over 30 years with modular facilities across Portugal.",
    prefabInnovationTitle:
      "Prefabrication of modular building components improves speed, quality, safety and the environment.",
    prefabInnovationText:
      "Golden M International is invested in lean-driven production facilities and modular construction services that include Design for Manufacture and Assembly (DfMA) methods, self-perform work and strategic procurement to overcome traditional construction challenges.",
    prefabInnovationLabel:
      "Modular Construction Services at Golden M International",

    // Industrial Services
    industrialConstructionServices: "Industrial Construction Services",
    industrialConstructionEngineering: "Industrial Construction Engineering",
    industrialModular: "Industrial Modular Construction",
    industrialSiteExecution: "Industrial Site Execution",
    peopleTeams: "People, Teams and Craft Labor Solutions",
    maintenance: "Industrial Maintenance and Turnaround",

    // Who We Are Dropdown
    whoWeAreTitle: "WHO WE ARE",
    leadership: "Leadership",
    innovation: "Innovation",
    safety: "Safety",
    aboutUs: "About Golden M International",
    ourHistory: "Our History",
    ourLeadership: "Our Leadership",
    aboutUsDescription:
      "Working with us means you have our 5,200+ network of experts beside you.",
    historyDescription:
      "From humble small-town roots, Golden M International became an international construction leader.",
    leadershipDescription:
      "Meet our leadership team who guides strategic operations across our company.",
    innovationDescription:
      "We are passionately leading the way in digitizing the construction industry.",
    safetyDescription:
      "Creating a safe and healthy work environment is a central guiding principle.",

    // Home Page
    whatWeBuildTitle: "WHAT WE BUILD",
    whatWeBuildSubtitle:
      "We look beyond your immediate construction needs to develop comprehensive solutions for each project",
    projectShowcase: "PROJECT SHOWCASE",
    location: "LOCATION:",
    market: "MARKET:",
    learnMore: "LEARN MORE",

    // Project Descriptions
    // uclaProjecDesc: "The Olympic and Centennial residence halls project for UCLA spans 371,000 sq. ft., consisting of ten floors above grade and 1,000 sq. ft. maintenance basement. Careful planning ensured continued service for students and staff while preserving the site's natural features and minimizing construction disruption.",
    // urbanProjectDesc: "This comprehensive urban infrastructure renewal project encompasses major roadway improvements, utility upgrades, and implementation of sustainable stormwater management systems across a 25-mile corridor, improving connectivity while minimizing environmental impact.",
    // manufacturingProjecDesc: "Our 450,000 sq. ft. state-of-the-art manufacturing facility features innovative modular construction methods, reducing build time by 30% while incorporating renewable energy systems that provide 40% of the facility's power needs.",
    // coastalProjectDesc: "This specialized research facility required innovative engineering solutions to withstand extreme coastal conditions while providing state-of-the-art laboratory spaces for marine scientists and sustainable design features that achieved LEED Platinum certification.",

    // Markets
    education: "EDUCATION",
    infrastructure: "INFRASTRUCTURE",
    manufacturing: "MANUFACTURING",
    research: "RESEARCH",

    // Footer
    contactUs: "Contact Us",
    ethicsCode: "Ethics/Code of Conduct",
    hourlyEmployee: "Hourly Employee Information",
    privacyPolicy: "Privacy Policy & Trademarks",
    toolsResources: "Tools & Resources",
    copyright: "Copyright © 2025 Golden M International Inc",
    allRightsReserved: "All rights reserved",
    privacyPolicyLink:
      "https://www.Golden M International.com/us/en/privacy-policy",
    followUs: "Follow Us",
    termsOfUse: "Terms of Use",

    // Common Actions
    viewMore: "View More",
    contactNow: "Contact Now",

    // Service Category Descriptions
    buildingsDescription:
      "From P3s and EPC delivery methods to preconstruction services, we're ready to support your needs.",
    civilDescription:
      "Our civil construction expertise spans infrastructure, transportation, and heavy civil projects across the country.",
    industrialDescription:
      "We deliver complex industrial projects with a focus on safety, quality, and operational excellence.",

    // Careers Page
    buildCareer: "Build Your Career With Us",
    careerHeroText:
      "Join Golden M International and be part of a team that's shaping the future of construction and engineering across Portugal.",
    applyNow: "Apply Now",
    whyWorkWithUs: "Why Work With Us",

    // Career Benefits
    collaborativeCulture: "Collaborative Culture",
    collaborativeCultureDesc:
      "Join a team that values your input and fosters collaboration across all levels.",
    careerGrowth: "Career Growth",
    careerGrowthDesc:
      "Clear pathways for advancement with mentorship and professional development opportunities.",
    competitiveBenefits: "Competitive Benefits",
    competitiveBenefitsDesc:
      "Comprehensive healthcare, retirement plans, and work-life balance initiatives.",
    impactfulProjects: "Impactful Projects",
    impactfulProjectsDesc:
      "Work on meaningful projects that shape communities and define skylines across Portugal.",

    // Open Positions
    openPositions: "Open Positions",
    seniorProjectManager: "Senior Project Manager",
    civilEngineer: "Civil Engineer",
    architecturalDesigner: "Architectural Designer",
    constructionSupervisor: "Construction Site Supervisor",
    fullTime: "Full-time",
    noPositionFit: "Don't see a position that fits your skills?",
    submitGeneral: "Submit a General Application",

    // Application Form
    joinOurTeam: "Join Our Team",
    formIntroText:
      "Fill out the form below to apply for a position at Golden M International. We'll review your application and get back to you as soon as possible.",
    firstName: "First Name*",
    lastName: "Last Name*",
    email: "Email Address*",
    phone: "Phone Number",
    positionInterest: "Position of Interest*",
    selectPosition: "Select a position",
    generalApplication: "General Application",
    yearsExperience: "Years of Experience*",
    selectExperience: "Select experience",
    whyJoinUs: "Why do you want to join Golden M International?",
    resumeCV: "Resume/CV*",
    uploadResume: "Upload Resume",
    acceptedFormats: "Accepted formats: PDF, DOC, DOCX (Max 5MB)",
    submitApplication: "Submit Application",

    // Form Success
    applicationSubmitted: "Application Submitted!",
    thankYouMessage:
      "Thank you for your interest in joining Golden M International. Our team will review your application and contact you soon.",

    // Experience Options
    zeroToTwo: "0-2 years",
    threeToFive: "3-5 years",
    sixToTen: "6-10 years",
    tenPlus: "10+ years",

    //  Emergency Page
    emergencyResponseCategory: "Buildings and Civil Service",
    emergencyResponseTitle:
      "Golden M International Emergency Response Capabilities",
    emergencyResponseDesc:
      "If your commercial property or critical infrastructure is experiencing an emergency—or you're looking to rebuild after a disaster—contact your local regional office of Golden M International for assistance.",
    emergencyOverviewTitle: "SERVICE OVERVIEW",
    emergencyInnovationTitle: "Ready to Respond, Ready to Rebuild",
    emergencyInnovationText:
      "When an emergency happens, getting back to business isn't as simple as calling a contractor. You need a partner with emergency experience and disaster preparedness, backed by a national network of resources and strong local presence. Golden M International is ready to meet your emergency construction needs—whether it's stabilizing a structure to prevent further damage, remediating water damage, or fully rebuilding.",
    emergencyInnovationLabel: "Emergency Response at Golden M International",

    // Emergency Page - Commitments Section
    emergencyMissionTitle: "OUR MISSION",
    emergencyMissionQuote:
      "When a business is shut down due to a storm or unexpected emergency, the entire community feels it. The sooner we can rebuild and restore full functionality, the sooner the people can get back to work and ultimately their lives can get back to normal. That is very rewarding feeling at the end of the day.",
    emergencyMissionName: "Malik Arshad",
    emergencyMissionRole: "CEO, Golden M International",

    // Locations
    lisbon: "Lisbon, Portugal",
    porto: "Porto, Portugal",
    faro: "Faro, Portugal",
    braga: "Braga, Portugal",
    coimbra: "Coimbra, Portugal",
    aveiro: "Aveiro, Portugal",
    evora: "Évora, Portugal",
    beja: "Beja, Portugal",

    // About Us Page
    aboutGoldenM: "ABOUT Golden M International",
    togetherBuildSuccess: "Together we build success",
    aboutMainText1:
      "From small renovations to complex billion dollar projects; from sports arenas to water treatment plants and petrochemical facilities, Golden M International has you covered.",
    aboutMainText2:
      "We redefine full-service and bring expertise across all project types, at all scales and under all procurement models. As innovative solution providers and construction specialists, we leverage our expertise to customize the right approach for your project to exceed your expectations.",
    aboutMainText3:
      "Collaborative, driven and innovative: we're focused on finding the best way forward and elevating your vision of success.",

    // How We Show Up
    howWeShowUp: "HOW WE SHOW UP",
    innovative: "Innovative",
    innovativeText:
      "We anticipate challenges and proactively develop new capabilities to address the evolving needs of our clients. Our relentless focus on innovation leads to smarter building practices and technology that reduces complexity throughout our projects.",
    driven: "Driven",
    drivenText:
      "We combine technical expertise with business acumen and a willingness to take on the most difficult projects. We go above and beyond the immediate construction needs to develop comprehensive solutions that support your larger business goals.",

    // Our Purpose
    ourPurpose: "OUR PURPOSE",
    purposeText:
      "As industry leaders, we model the highest standards of corporate social responsibility with uncompromising commitment to diversity, inclusion, sustainability and innovation. We do this in collaboration with our clients, partners and communities to build a better future, together.",

    // By The Numbers
    byTheNumbers: "GOLDEN M INTERNATIONAL UNIPESSOAL BY THE NUMBERS",
    employeeOwned: "Employee-Owned",
    salariedEmployees: "Salaried Employees",
    usOffices: "U.S. Offices",
    annualVolume: "Annual Construction Volume in 2024 (USD)",
    donatedAmount: "Donated to Community Organizations in 2024 (USD)",
    projectsUnderway: "Projects Underway",

    // Our Commitments
    ourCommitments: "OUR COMMITMENTS",
    everyDecisionImpact: "We know that every decision has an impact",
    commitmentsDescription:
      "Our commitments to safety, quality, sustainability and community stewardship ensure your lasting success.",

    // Commitment Cards
    safety: "Safety",
    safetyText:
      "We will never compromise the safety of our people. Our goal is zero incidents and our lost time frequency rate is industry leading.",
    quality: "Quality",
    qualityText:
      "Consistency ensures success. We see projects through and proactively develop solutions to exceed expectations.",
    sustainability: "Sustainability",
    sustainabilityText:
      "We look beyond sustainable construction with a holistic approach to corporate social responsibility that addresses partners, people, projects, practices and places.",
    stewardship: "Stewardship",
    stewardshipText:
      "Our culture of giving empowers employees to give back to the community. In 2019, more than $9.4 million was donated to community organizations by Golden M International UniPessoal and our employees.",
    readMore: "READ MORE",

    // Hero Slides
    culture: "CULTURE",
    manufacturing: "MANUFACTURING",
    majorMilestone: "MAJOR MILESTONE",
    fortuneCompany: "Fortune 100 Best Companies to Work For® 2025",
    digitalTwins: "Leveraging Digital Twins in Manufacturing",
    coloradoAnniversary: "Celebrating 50 Years of Building Colorado",
    readStory: "READ THE STORY",
    employeeOwned100: "100% Employee-Owned",
    digitalTwinsText: "Digital Twins",
    colorado50Years: "50 Years in Colorado",

    // Delivery Page
    service: "SERVICE",
    projectDeliveryModels: "Project Delivery Models",
    deliveryModelDescription:
      "Every project is unique in terms of project type, budget, schedule, financing objectives, available resources and appetite for risk. Project delivery models vary accordingly and can be adapted to address client-specific requirements.",
    serviceOverview: "SERVICE OVERVIEW",
    innovationTitle:
      "We work with clients to ensure the project delivery model accommodates your unique interests.",
    innovationText:
      "To meet project goals, clients must choose their preferred project delivery method and level of involvement early in the process. Golden M International is flexible and will customize project delivery methods to deliver the best value to meet your business needs.",
    innovationLabel: "INNOVATION AT Golden M International",

    // Construction Management
    cmTitle:
      "Construction Management Variations: From Agency and At Risk to GMP",
    cmSubtitle: "A DELIVERY MODEL FOR EVERY NEED",
    cmDescription:
      "The hallmark of CM is the opportunity for early engagement of our preconstruction experts who collaborate to optimize value by developing construction methods, materials and solutions that result in quality enhancements, serviceability and improved life cycle. We apply our knowledge of construction costs, schedule and market trends to ensure the project is executed on budget, while minimizing risk associated with incomplete scope of work. Under CM, all project costs are typically reimbursable.",
    viewSelfPerform: "VIEW OUR SELF-PERFORM SERVICES",

    // Design Build
    dbTitle:
      "Turn-Key Contract: Golden M International as Your Single Source Design Builder and Risk Owner",
    dbDescription:
      "As design builder, we own the risk for both design and construction of your project, based on prescribed Project-Specific Output Specifications. DB is highly collaborative as the full project team comes together early in design. Combined expertise drives value to design and construction outcomes, effectively mitigating the risk of scope and cost escalation. DB ensures cost effective, quality facilities typically delivered on reduced schedules as construction can begin prior to design completion.",
    // learnMore: "LEARN MORE",

    // Main Page - What We Do 2 Section
    whatWeDo2Title: "WHAT WE DO",
    whatWeDo2Subtitle: "Experience Across Markets",
    buildingsTabTitle: "Buildings",
    buildingsTabHeading: "Modern Architecture for Contemporary Needs",
    buildingsTabDesc:
      "We specialize in creating innovative construction solutions that combine aesthetics with functionality. Our buildings are designed with sustainability and efficiency in mind, ensuring they meet today's needs while being prepared for tomorrow's challenges.",

    civilInfraTabTitle: "Civil Infrastructure",
    civilInfraTabHeading: "Building Society's Foundation",
    civilInfraTabDesc:
      "Our infrastructure projects connect communities and drive economies. From roads and bridges to water systems and power networks, we deliver robust solutions that stand the test of time while minimizing environmental impact.",

    heavyIndTabTitle: "Heavy Industrial",
    heavyIndTabHeading: "Driving Industrial Progress",
    heavyIndTabDesc:
      "We have extensive experience in constructing complex industrial facilities that require specialized knowledge and precision. Our industrial projects support manufacturing, power generation, and resource processing with an emphasis on safety and operational efficiency.",

    specialProjTabTitle: "Special Projects",
    specialProjTabHeading: "Unique Solutions for Specialized Needs",
    specialProjTabDesc:
      "The best of both worlds: the commitment, responsiveness and quality of a local contractor, along with the expertise, knowledge and safety culture of a large contracting organization. Using a hands-on, individualized approach in Special Projects, precision consistently delivers exceptional results for new and repeat clients.",

    // Main Page - Owners Section
    ownersTitle: "Employee-Owned, Client-Focused",
    ownersDesc:
      "As an employee-owned company, we are personally invested in your success",
    employeeOwnership: "100% Employee Ownership",
    clientSuccess: "Dedicated to Client Success",

    // Alternative Financing
    afTitle: "Alternative Financing and Public-Private Partnerships",
    afDescription:
      "This rigorous project delivery method transfers risk to entities that, as an integrated 'project company', are best placed to manage risk, namely: financiers, developers, contractors, consultants and operators. The public sector can transfer operating, maintenance, construction, financing and schedule risk from taxpayers to the private sector enabling quality on time/on budget, fast-track project delivery. As risk owners, the project company, in turn, receives a long-term commitment of revenue. Golden M International Investments is our development and equity investment entity and oversees consortium leadership, strategy, bid development, commercial structuring, arrangement of project financing and, for projects that require it, equity investment.",
    exploreMethods: "EXPLORE OUR METHODS",

    // EPC
    epcTitle: "Engineer Procure Construct (EPC)",
    epcDescription:
      "Complex industrial-scale project clients prefer the EPC method when they want a single entity to deliver a turn-key project. Golden M International has put in place 2 Giga Watts of utility-scale solar field projects under the EPC model wherein we perform and manage all project engineering, procurement and construction activities with an engineering firm. We build a collaborative working relationship, founded on mutual respect and appreciation among all disciplines, to realize a shared commitment to project goals.",

    // IPD
    ipdTitle: "Integrated Project Delivery",
    ipdDescription:
      "A collaborative approach to delivering projects, IPD requires early involvement of owners, designers, builders and key stakeholders. This results in greater transparency and integration of resources, optimizes value, reduces waste and maximizes efficiency through all phases.",

    // Project Names
    uclaHalls: "UCLA Olympic and Centennial Residence Halls",
    urbanInfrastructure: "Urban Infrastructure Renewal Project",
    manufacturingFacility: "Advanced Manufacturing Facility",
    researchCenter: "Coastal Research Center",

    // Project Locations
    california: "CALIFORNIA",
    oregon: "OREGON",
    texas: "TEXAS",
    florida: "FLORIDA",

    // Image Alt Texts
    serviceIllustration: "Service illustration",
    featureImage: "Feature image",
    teamCollaborating:
      "Team collaborating in a meeting room with building designs on screens",
    teamWorking: "Team working on target value design process",
    innovativeTechniques:
      "Innovative construction techniques being implemented on site",
    slide: "Slide",
    companyLogo: "Golden M International Construction Logo",
    cityscape: "Lisbon cityscape with Tagus river and buildings",
    architecturalVisualization:
      "3D architectural visualization of building structure",
    constructionBlueprint: "Complex construction blueprint visualization",
    projectAnnouncement: "New project announcement",
    awardCeremony: "Award ceremony",
    industryConference: "Industry conference",
    digitalConstruction: "Digital construction",
    industrialEquipment: "Advanced industrial equipment",
    constructionWorker: "Construction worker with safety equipment",
    solarPanels: "Solar panels on building",
    recycledMaterials: "Recycled construction materials",
    communityOutreach: "Community outreach program",
    teamBuilding: "Team building event",
    marketAnalysis: "Market analysis chart",
    urbanDevelopment: "Urban development project",
    presidentPortrait: "Joe Carrieri - President and General Manager",
    safetyOnSite: "Construction workers with safety equipment on site",

    // Accessibility Labels
    searchButton: "Search button",
    languageSelector: "Language selector",
    menuButton: "Menu button",
    closeButton: "Close button",

    // Service Descriptions
    smartConstructionDesc:
      "Our smart construction solutions leverage cutting-edge technology to enhance project efficiency and outcomes.",
    maintenanceDesc:
      "Comprehensive industrial maintenance and turnaround services to optimize facility performance and minimize downtime.",

    // Showcase Sections
    showcaseTitle1: "Innovative Solutions",
    showcaseDesc1:
      "Leading the industry with advanced construction methodologies and technologies.",
    showcaseTitle2: "Sustainable Practices",
    showcaseDesc2:
      "Implementing eco-friendly construction practices for a better tomorrow.",

    // Construction Efficiency
    constructionEfficiencyTitle:
      "Maximizing design and construction efficiencies early adds measurable value and reduces risk.",

    // Safety Section
    safetyTitle: "Safety: A Way of Life",
    safetyText:
      "Our culture of safety is one that extends beyond the job site to ensure everyone returns home safely every day.",
    safetyLearnMore: "LEARN MORE",

    // Smart Construction Slides
    floodProtectionTitle:
      "Flood Protection and Insurance Savings with Eddy Solutions",
    floodProtectionSubtitle: "THE VALUE OF PRECONSTRUCTION",
    floodProtectionDesc:
      "Flooding and water damage are costly building risks. That's why Golden M International partnered with Eddy Solutions to integrate Eddy's smart water monitoring and leak mitigation technologies into Job Site Insights™. With Eddy, JSI™ can monitor, control and conserve water usage, protecting a building and critical systems against the risk of water damage during construction. Reduce your insurance premiums and protect your built assets through and post-construction with Golden M International.",

    deRiskingTitle:
      "De-risking Projects with Job Site Insights™, the Smart IoT Platform",
    deRiskingSubtitle: "Proven Innovations",
    deRiskingDesc:
      "JSI™ is a cloud-based, smart construction platform that provides trend monitoring of potential issues on our projects through sensors that monitor and measure temperature, humidity, water/flooding, vibration and sound. Engaged in over 63 projects, JSI™ creates a real-time sensor tracking model accessible from any device. The insights gained from JSI™ reduce energy use, rework and insurance costs, while data is stored for future analytics.",

    innovativeMethodsTitle: "Innovative Construction Methods",
    innovativeMethodsDesc:
      "The CopperTree Analytic's data and energy analytics platform turns raw data from building automation and mechanical systems into actionable insights that improves commissioning and building management. CopperTree reads all data points from building management systems and can be used to provide deep analysis of all mechanical systems against design specifications. Armed with actionable data, building managers can make informed and strategic decisions to reduce energy consumption, target maintenance efforts and increase efficiency. CopperTree continues to deliver value to clients as part of a building's operational workflow.",

    // Industrial Maintenance Slides
    heatExchangersTitle: "Heat Exchangers",
    heatExchangersSubtitle: "People, Teams and Labor Solutions",
    heatExchangersDesc:
      "Golden M International offers specialized hydraulic equipment to remove, repair and install heat exchangers safely. Our custom designed equipment can handle the largest integrated heat exchangers to the smallest hairpin tube bundles. Our extractors are self-contained units that can be easily lifted into position utilizing one crane and operated remotely. Golden M International currently owns one 25T extractor, three 45T extractors and our newest addition, an 85T custom built extractor.",

    ventilationTitle: "Confined Space Ventilation",
    ventilationDesc:
      "Properly ventilated confined spaces are critical to the safety of your employees and projects. Our in-house calculations, design, specialty equipment and technicians can improve air quality by removing and capturing particles such as welding fumes, RCF's, sandblasting and non-explosive dusts. A well planned and executed ventilation system improves confined space productivity by increasing visibility and comfort as well as ensuring environmental responsibility.",

    machiningTitle: "Machining",
    machiningDesc:
      "Golden M International has a fully-integrated team of machinists to provide innovative, cost-effective solutions to reduce overheads and increase versatility. With over 20 years' of experience in the portable machining industry, we utilize skilled composite crews and our in-house competency training to ensure safe operation of this specialized equipment. From the smallest diameter to the largest, Golden M International has all your machining needs covered.",

    viewSelfPerform: "VIEW OUR SELF-PERFORM SERVICES",
    learnMoreCta: "LEARN MORE",
    exploreMethods: "EXPLORE OUR METHODS",

    // Content Tabs
    latest: "Latest",
    thoughtLeadership: "Thought Leadership",
    innovation: "Innovation",
    sustainability: "Sustainability",
    cultureAndCommunity: "Culture & Community",
    marketHighlights: "Market Highlights",

    // Latest News
    latestNewsTitle: "Latest News & Updates",
    newHQTitle: "New Headquarters Project Breaks Ground",
    newHQDesc:
      "Golden M International has officially broken ground on its new headquarters in Lisbon, featuring state-of-the-art sustainable design and collaborative workspaces.",
    awardTitle: "Golden M Wins Excellence in Construction Award",
    awardDesc:
      "Our Porto residential development project has been recognized for outstanding quality and innovation at the annual Construction Excellence Awards.",

    // Thought Leadership
    sustainableConstructionTitle:
      "The Future of Sustainable Construction in Portugal",
    sustainableConstructionDesc:
      "Our Chief Sustainability Officer explores how Portugal is positioning itself as a leader in green building practices and what this means for the future of construction.",
    digitalTransformationTitle:
      "Digital Transformation in Construction Management",
    digitalTransformationDesc:
      "How digital tools and technologies are revolutionizing project management and execution in the construction industry, with real-world examples from our recent projects.",

    // Innovation Content
    buildingSystemsTitle: "Advanced Building Systems Integration",
    buildingSystemsDesc:
      "Golden M International is pioneering the integration of smart building systems that optimize energy usage, enhance occupant comfort, and reduce maintenance costs through predictive analytics and IoT sensors.",
    safetyProtocolsTitle: "Next-Generation Safety Protocols",
    safetyProtocolsDesc:
      "Our innovative approach to construction safety combines wearable technology, real-time monitoring, and AI-powered risk assessment to create safer work environments and prevent accidents before they happen.",

    // Sustainability Content
    netZeroTitle: "Net-Zero Building Initiatives",
    netZeroDesc:
      "Golden M International is committed to achieving net-zero carbon emissions in all new construction projects by 2030. Our comprehensive approach includes renewable energy integration, sustainable materials, and energy-efficient design.",
    circularEconomyTitle: "Circular Economy in Construction",
    circularEconomyDesc:
      "We're implementing circular economy principles in our projects, focusing on waste reduction, material reuse, and designing buildings for future adaptability and deconstruction.",

    // Culture & Community
    buildingCommunitiesTitle: "Building Communities, Not Just Structures",
    buildingCommunitiesDesc:
      "Our community engagement programs focus on creating lasting positive impact in the areas where we work. From local hiring initiatives to supporting neighborhood revitalization, we believe in building communities from the ground up.",
    fosteringCultureTitle: "Fostering a Culture of Excellence",
    fosteringCultureDesc:
      "At Golden M International, our people are our greatest asset. We invest in continuous learning, diversity and inclusion initiatives, and creating a workplace where innovation and collaboration thrive.",

    // Market Analysis
    marketOutlookTitle:
      "Perspectivas do Mercado de Construção em Portugal 2023-2024",
    marketOutlookDesc:
      "Nossa análise das tendências atuais do mercado, setores de crescimento e oportunidades de investimento na indústria de construção portuguesa, com foco especial no desenvolvimento residencial, comercial e de infraestrutura.",
    urbanRegenerationTitle:
      "Tendências Emergentes: Projetos de Regeneração Urbana",
    urbanRegenerationDesc:
      "A regeneração urbana está se tornando um foco-chave nas principais cidades de Portugal. Examinamos os impulsionadores econômicos, o panorama regulatório e os fatores de sucesso para esses projetos transformadores.",

    buildingService: "Building Service",

    ourHistoryTitle: "Our History",
    ourHistorySubtitle: "Let's Walk through our company history",
    ourStoryTitle: "Our Story",
    ourStoryParagraph1:
      "Founded in 2015, Golden M International started with a clear vision — to revolutionize the construction industry through quality, innovation, and trust. What began as a small team with big dreams quickly transformed into one of Portugal’s most reliable construction partners, known for its commitment to excellence and client-first approach.",
    ourStoryParagraph2:
      "From delivering modular buildings to executing emergency response projects, we've grown by embracing cutting-edge technologies and sustainable methods. Our journey has always been driven by people — our passionate teams, loyal clients, and the communities we serve. Today, we continue to build not just structures, but a legacy of resilience, precision, and purpose.",

    // Common Actions
    downloadReport: "Baixar Relatório",
    readAnalysis: "Ler Análise",
    // readStory: "Ler História",
    joinTeam: "Junte-se à Nossa Equipe",
    viewCaseStudies: "Ver Estudos de Caso",
    exploreApproach: "Explore Nossa Abordagem",
    ourCommunityImpact: "Nosso Impacto na Comunidade",

    //consEff2 Description
    consEff2Desc:
      "When engaged early, our solution providers and advanced technology drive value to your bottom line.",

    // Dates
    june15: "15 de Junho, 2023",
    may28: "28 de Maio, 2023",

    // Team Members
    csoName: "Por Maria Santos, CSO",
    ctoName: "Por João Oliveira, CTO",

    //Pre Fab Slides
    modularComponentsTitle:
      "Modular Components 'Kit of Parts' Approach: Flexible and Familiar",
    ourApproach: "Our Approach",
    modularComponentsDesc:
      "Key building elements are prefabricated and then shipped to site to be sequenced into the building. The Kit of Parts may include: Precast core elements, stairs and elevator shafts, load bearing structural interior/exterior walls, interior non-bearing walls, prefabricated washrooms and mechanical/electrical rooms. The approach requires less up-front design work to release specific components to fabrication and uses readily available materials and construction methods well understood by trades.",
    viewSelfPerform: "VIEW OUR SELF-PERFORM SERVICES",
    teamCollaborating:
      "Team collaborating in a meeting room with building designs on screens",

    volumetricApproachTitle:
      "Full Volumetric Approach: 'Lego Block' On-Site Assembly",
    volumetricApproachDesc:
      "Full volumetric modular is a process whereby large building modules are manufactured off site, then assembled on site like Lego blocks to create the structure and a near finished building. With the majority of 'construction' transferred to a facility, volumetric construction has the potential to reduce on site waste by 90% while the manufacturing and erection process produces less than 0.6% waste to landfill. Early integrated design modeling and resolution prior to module production is critical.",

    dfmaTitle:
      "Design for Manufacture and Assembly (DfMA): An Engineering Methodology",
    dfmaDesc:
      "DfMA works to accelerate production and reduce costs by ensuring both ease of manufacture of modular components as well as simplified assembly of those components into the final module, all during the early and iterative design phase of the project. Working with advance BIM technologies, our modular design experts and process engineers source cost-effective raw materials and work to Lean both the manufacturing and module assembly processes in order to reduce labor, time, costs and complexities.",

    lessonsLearnedTitle:
      "30+ Years in Modular Construction: Modular Construction Lessons Learned",
    lessonsLearnedDesc:
      "Golden M International has walked the challenging modular construction journey and, having delivered everything from prefabricated HVAC plenums to fully fitted-out washroom mods to full volumetric data centers, site offices and even a public library facility, brings a superior depth of Lessons Learned and Best Practices to the table. We ensure clients receive experience-based modular construction means and methods expertise to assess the risks and drive the right decisions and solutions to achieve your objectives.",

    // What We Build Tabs

    buildingsTab: "Buildings",
    civilTab: "Civil",
    industrialTab: "Industrial",
    specialProjectsTab: "Special Projects",

    // Project Labels
    projectLabel: "PROJECT SHOWCASE",
    locationLabel: "LOCATION:",
    marketLabel: "MARKET:",

    // Project Markets
    educationMarket: "EDUCATION",
    infrastructureMarket: "INFRASTRUCTURE",
    manufacturingMarket: "MANUFACTURING",
    researchMarket: "RESEARCH",

    // Project Locations
    californiaLocation: "CALIFORNIA",
    oregonLocation: "OREGON",
    texasLocation: "TEXAS",
    floridaLocation: "FLORIDA",

    // Project Names
    uclaProject: "UCLA Olympic and Centennial Residence Halls",
    urbanProject: "Urban Infrastructure Renewal Project",
    manufacturingProject: "Advanced Manufacturing Facility",
    researchProject: "Coastal Research Center",

    // Project Descriptions
    uclaProjectDesc:
      "The Olympic and Centennial residence halls project for UCLA spans 371,000 sq. ft., consisting of ten floors above grade and 1,000 sq. ft. maintenance basement. Careful planning ensured continued service for students and staff while preserving the site's natural features and minimizing construction disruption.",
    urbanProjectDesc:
      "This comprehensive urban infrastructure renewal project encompasses major roadway improvements, utility upgrades, and implementation of sustainable stormwater management systems across a 25-mile corridor, improving connectivity while minimizing environmental impact.",
    manufacturingProjectDesc:
      "Our 450,000 sq. ft. state-of-the-art manufacturing facility features innovative modular construction methods, reducing build time by 30% while incorporating renewable energy systems that provide 40% of the facility's power needs.",
    researchProjectDesc:
      "This specialized research facility required innovative engineering solutions to withstand extreme coastal conditions while providing state-of-the-art laboratory spaces for marine scientists and sustainable design features that achieved LEED Platinum certification.",

    // Industrial Engineering Page
    industrialEngService: "INDUSTRIAL SERVICE",
    industrialEngTitle: "Engineering Services",
    industrialEngDesc:
      "Golden M International's engineering department provides support and services to all our projects as well as our fabrication facilities and module yards. This includes anything from performing lift studies to redesigning engineering items to current standards.",
    industrialEngInnovTitle:
      "Innovative technologies help to lean processes and drive value to your bottom line.",
    industrialEngInnovText:
      "Beyond adopting off-the-shelf technology, proactively partners with tech leaders to develop unique programs focused on resolving typical client pain points.",
    industrialEngInnovLabel:
      "Industrial Construction Services AT Golden M International",

    // Industrial Engineering Showcase
    preconstructionTitle: "Support to Preconstruction",
    preconstructionDesc:
      "Our in-house design programs help in process equipment analysis, sequence analysis, and heavy lift planning, as well as anything needed during the constructability phase. We also continually research, develop and provide solutions and training to our field and fabrication personnel.",
    awpTitle: "Advanced Work Packaging (AWP)",
    awpDesc:
      "We utilize AWP best practices from the Construction Industry Institute (CII) and the Construction Owners Association of Alberta (COAA). This process provides Golden M International with the framework to organize a scope of work into manageable portions that improve productivity, safety, quality, and tracking of construction work, providing a construction-driven project and cohesive execution plan to our clients for the project's lifecycle.",

    // Industrial Engineering Slides
    heviLiftTitle: "HeviLift Analysis",
    heviLiftSubtitle: "Construction Services by Constructors",
    heviLiftDesc:
      "HeviLift is Golden M International's 5D heavy lift planning software suite. Developed in house, HeviLift allows us to run hundreds of thousands of module lift scenarios to determine the most optimal and cost-effective delivery for our clients. Conceptualized in 2005, HeviLift was created to automate crane selection as part of the bidding process and construction planning, which manually was very time consuming.",

    liftFrameTitle: "Engineered Module Lift Frame",
    liftFrameSubtitle: "Construction Services by Constructors",
    liftFrameDesc:
      "Golden M International's patented lift frame has reduced by as much as 90% the time required to modify rigging configurations over traditional assemblies. This innovative method of rigging modules and other loads substantially reduces the HSE exposure hours and increases the cost effectiveness of the overall heavy lift program. What used to take up to a day now takes a matter of hours, setting a new bar for productivity and safe work practices.",

    researchTitle: "Research and Special Projects",
    researchSubtitle: "Construction Services by Constructors",
    researchDesc:
      "For the past two decades, Golden M International has been heavily involved with the construction and engineering programs at both the University of Alberta and the University of Houston. These varied and highly technical research programs have led to several application developments that have moved the industry forward. Topics covered include artificial intelligence, 3D modelling, discrete event simulation and automation.",

    hydrotestTitle: "Optimized Hydrotest Packaging",
    hydrotestSubtitle: "Construction Services by Constructors",
    hydrotestDesc:
      "Crafting an optimum hydrotest package requires the effort of a number of analysts reviewing the input of multiple line lists, isometrics, and piping and instrumentation drawings. Cascade, our new method of defining and optimizing test packages uses intelligent 3D models to source key data points from the surrounding noise. Our algorithm allows analysts to define and scope test packages at twice the current rate while avoiding ongoing revisions, delays, and increased project costs.",

    // Industrial People Page
    industrialPeopleService: "INDUSTRIAL SERVICE",
    industrialPeopleTitle: "People, Teams and Craft Labor Solutions",
    industrialPeopleDesc:
      "With expertise in both greenfield and brownfield projects, our highly experienced teams are committed to the success of our clients and work with you to provide consistent and reliable project management and craft labor solutions.",
    industrialPeopleInnovTitle:
      "Experienced project management and site teams for your project",
    industrialPeopleInnovText:
      "We hand-select project management teams and can scale our workforce as needed. We execute the majority of work on a direct-hire basis and our teams can oversee everything from engineering deliverables to construction and subcontract management.",
    industrialPeopleInnovLabel:
      "Industrial Construction Services AT Golden M International",

    // Industrial People Showcase
    ownershipTitle: "Our Culture of Ownership",
    ownershipDesc:
      "We know our people are our most important asset and we have been fortunate to find and employ some of the most innovative, respected and diverse construction professionals. As employee owners, our teams have a vested interest in bottom line productivity and work hard to achieve our clients' goals.",
    mentoringTitle: "Mentoring and Culture",
    mentoringDesc:
      "Most of our staff have long tenures with Golden M International and, as part of their leadership training, mentor colleagues to help aid in their development. Our teams work together from project to project, which in turn brings consistency and predictability to every new project.",

    // Industrial People Slides
    directHireTitle: "Direct-Hire Labor",
    directHireSubtitle: "People, Teams and Labor Solutions",
    directHireDesc:
      "Golden M International's construction management software stack, developed over the past decade, is a fully-integrated application suite that can be modularized and tailored to meet the lifecycle needs of any industrial construction project, with a focus on transitioning seamlessly from bulk area-based construction to system turnover and startup. The applications that comprise the stack run the gamut from estimating to costing to planning, packaging, inspection, completions and documentation.",

    workforceTitle: "Workforce Management Software",
    workforceSubtitle: "People, Teams and Labor Solutions",
    workforceDesc:
      "Golden M International uses an in-house developed craft worker tracking software to assess the labor availability in the project's region, giving us a good understanding of whether or not supplemental craft will be required from other geographies. This program gives Golden M International some predictability and certainty to ensure our craft labor will be available to deliver the project to the client.",

    trainingTitle: "Training and Support",
    trainingSubtitle: "People, Teams and Labor Solutions",
    trainingDesc:
      "Golden M International has a strong training and mentorship program that provides craft with the necessary skills to safely and effectively perform their work activities. Training programs are developed based on the individual experience and with the specific nuances for the project in mind. Golden M International also proudly supports a variety of post-secondary and trades schools to assist in promoting the construction sector and providing individuals with the required skills during their apprenticeships.",

    historyQuote: "Building a legacy of excellence, one project at a time.",
    ceoQuote: "Malik Arshad, CEO of Golden M International",

    // Industrial Execution Page
    industrialExService: "INDUSTRIAL SERVICE",
    industrialExTitle: "Site Execution",
    industrialExDesc:
      "Executing industrial construction projects for more than 70 years, Golden M International has the experience and resume to safely and successfully construct projects of any size in multiple sectors across North America.",
    industrialExInnovTitle: "Full Service Solutions",
    industrialExInnovText:
      "Golden M International provides construction services for a facility's full life cycle, including greenfield construction, commissioning and start-up support services, sustaining capital upgrades, as well as maintenance and turnaround.",
    industrialExInnovLabel:
      "Industrial Construction Services AT Golden M International",

    // Industrial Execution Showcase
    collaborativeTitle: "Collaborative Construction Approach",
    collaborativeDesc:
      "Leveraging our long-term staff's proven experience, we work closely with our clients and engineering partners to deliver solutions to the complex and unique challenges of your project. By engaging our team earlier in the design phase, Golden M International can aid in a more efficient and safer execution.",
    fullServiceTitle: "Full-Service Scalable Project Delivery",
    fullServiceDesc:
      "Golden M International can deliver a tailorable execution that is suited to each project's needs, including lean construction principles, fabrication capabilities, in-house engineering solutions, appropriate level of project control and scalable construction teams.",
    workfaceTitle: "Workface Planning",
    workfaceDesc:
      "Golden M International embraces the use of workface planning on our projects. In simple terms, the practice entails getting the right things to the right people at the right time to save money and improve productivity on construction projects.",

    // Industrial Execution Slides
    earlyEngagementTitle: "Early Project Engagement",
    earlyEngagementSubtitle: "Project Management",
    earlyEngagementDesc:
      "Golden M International promotes Early Contractor Involvement during the development stages of the project to provide constructability input, propose innovative construction methods and assist in risk mitigation once the project hits construction. Golden M International believes in engaging clients and engineering partners early to provide construction input throughout the entire lifecycle of the project.",

    fabricationTitle: "Fabrication and Module Assembly",
    fabricationSubtitle: "Project Management",
    fabricationDesc:
      "Golden M International owns and operates pipe fabrication in both Canada and the United States and module assembly facilities that can provide third-party fabrication as well as support to our field operations. The facilities are tailored to meet the site scheduling requirements, while maintaining a manufacturing style approach producing pipe spools and modules for multiple clients at the same time.",

    projectManagementTitle: "Project Management",
    projectManagementSubtitle: "Project Management",
    projectManagementDesc:
      "Prior to mobilizing to the field, the selected project team develops the path of construction, the project execution methodologies and the construction work packages so the team is ready once they hit the field. Golden M International uses a scalable project management team with a combination of onsite and home office support to assist in reducing costs and increasing efficiencies.",

    commissioningTitle: "Project Commissioning",
    commissioningSubtitle: "Project Management",
    commissioningDesc:
      "Prior to bulk construction being completed, Golden M International will work with our client to develop a commissioning and close-out plan to be able to pivot to systems turnovers efficiently. During commissioning Golden M International can provide support to the client to complete the necessary activities to aid in a successful start-up of the facility.",

    // Mission Section
    ourMission: "OUR MISSION",
    missionQuote:
      "At the heart of everything we build is teamwork. We don't just assign tasks — we share goals. When we collaborate, we don't just get the job done — we elevate it. Every project is a group win.",
    ceoName: "Malik Arshad",
    ceoTitle: "CEO, Golden M International",

    // Innovation Page
    buildingsTitle: "Buildings",
    buildingsDesc:
      "As innovative solution providers, we leverage the latest technologies, workflows and practices to enable early and accurate decision making, cost and schedule certainty, and a high-quality building. These innovations enhance collaboration among our staff, subcontractors and designers to ensure mutual success.",

    civilTitle: "Civil",
    civilDesc:
      "Whether using laser scans to better understand utilities and infrastructure or creating 3D models to detect clashes between systems, our Civil Infrastructure division focuses on innovation and technology that improves performance and delivers safer, cost-effective infrastructure.",

    industrialTitle: "Industrial",
    industrialDesc:
      "We've been self-performing our work for decades and in that time have built a considerable institutional memory. We learn, find efficiencies, obtain best practices and discover new approaches with every project. Our acquired knowledge and expertise have driven the creation of an application-based software suite that we offer as a customisable solution to our clients.",

    innovationsTitle: "Innovations at Golden M International",
    innovationsQuote:
      "Golden M International's vision and tech/innovation leadership in the construction industry was formative in forging the Golden M International/CopperTree Partnership, to pursue advances in artificial intelligence and machine learning to deliver a timely and cost savings solution.",

    // Innovation Hero
    innovationCategory: "Innovation",
    innovationHeadline: "Innovation at Golden M International",

    // Innovation Section
    innovSectionHeading: "Continuous innovation helps us build a better future",
    innovSectionPara1:
      "Innovation requires creativity, opportunity, courage and execution. It also requires collaboration and a future-focused vision of construction. We embrace these aspects of innovation to build better products, enhance client value and drive new opportunities.",
    innovSectionPara2:
      "We deliver high-quality outcomes on aggressive fast-track schedules while ensuring safety for all. We rely on our use of advanced technologies to enhance project reporting, collaboration and communications; leverage data analytics, quality control and risk management; facilitate coordinated design validation, optimization and constructability; and streamline commissioning, turnover and O&M processes.",
    innovSectionPara3:
      "Golden M International is firmly at the forefront of construction innovation, from award-winning digital dashboards to BIM turnover models, virtual collaboration, and our smart construction platform, Job Site Insights™. We bring the full power of tested technologies to maximize schedule and cost savings for our clients.",
    companyName: "Golden M International",

    // Self Perform Page
    selfPerformTitle: "Self-Perform Capabilities",
    selfPerformDesc:
      "We bring a builder's mindset to all our work. Our people learn the business from the ground up on a variety of project types drive value through creating cost efficiencies, schedule certainty and flexibility on all our projects.",
    serviceOverview: "SERVICE OVERVIEW",
    selfPerformServicesTitle: "Self-perform services that work for you",
    selfPerformServicesDesc:
      "Our workforce has years of hands-on experience, training and skills development in the field. Our teams leverage their deep understanding of construction to deliver exceptional work.",
    sustainableConstructionServices:
      "Sustainable Construction Services at Golden M International",

    //NewsRoom Article
    compNews: "COMPANY NEWS",
    compNewsTitle:
      "Golden M International Expands Operations in Lisbon, Bringing Commercial Expertise to One of Portugal's Fastest-Growing Markets",
    newsRelease: "News Release",
    articleDate: "Apr 30, 2025",

    //Commitments Self-Perform
    selfPerformCapabilities: "Self-Perform Capabilities",
    quote:
      "As a construction company in Portugal, our self-perform capabilities are our backbone — from groundwork to finishes, we execute every phase with our own skilled teams. It's how we ensure quality, accountability, and on-time delivery, every time.",
    personName: "Malik Arshad",
    personTitle: "CEO, Golden M International",

    //self perform Slides
    selfPerformSuccessTitle: "Proven Success in Self-Perform",
    selfPerformSuccessDesc:
      "As one of Portugal top general contractors, we are grounded by the experience of being builders first and foremost. We have the capacity to self-perform through direct-hire craft and supervision of a variety of scopes of work with varies complexities, from site logistics and excavation to selective demolition and finished concrete. We leverage a skilled workforce that best suits your projects needs.",
    viewSelfPerformServices: "VIEW OUR SELF-PERFORM SERVICES",

    selfPerformAdvantagesTitle: "Showcasing the Advantages of Self-Perform",
    selfPerformAdvantagesDesc:
      "Self-performing construction work offers numerous benefits, including cost savings, schedule certainty, and improved quality control. By managing the entire construction process in-house, we can ensure that each project is completed to the highest standards, on time and within budget.",

    // Industrial Module Page
    industrialModService: "INDUSTRIAL SERVICE",
    industrialModTitle: "Industrial Module Assembly",
    industrialModDesc:
      "Golden M International Industrial's module assembly yard has made continuous improvement and lean construction the cornerstone of our success. We put 40 years of experience and expertise to work on your project.",
    industrialModInnovTitle:
      "Innovative technologies help to lean processes and drive value to your bottom line.",
    industrialModInnovText:
      "Beyond adopting off-the-shelf technology, proactively partners with tech leaders to develop unique programs focused on resolving typical client pain points.",
    industrialModInnovLabel:
      "Industrial Construction Services AT Golden M International",

    // Industrial Module Slides
    hassleTitle: "Hassle-free Delivery",
    hassleSubtitle: "Industrial Module Assembly Services",
    hassleDesc:
      "Golden M International's module assembly facilities are among the largest in Canada and ideally situated for heavy-haul transport across North America via truck or rail. Our in-house customs specialists will support and assist with module imports.",

    scheduleTitle: "Schedule Certainty",
    scheduleSubtitle: "Industrial Module Assembly Services",
    scheduleDesc:
      "Golden M International offers a complete solution that includes major procurement, bulk procurement, pipe fabrication self-directed modules assembly and management of subcontracted services. We can handle any size project and ensure on-time delivery due to our facility capacity and systematic production management.",

    sectorsTitle: "Modules for any Sector",
    sectorsSubtitle: "Industrial Module Assembly Services",
    sectorsDesc:
      "Golden M International has module assembly expertise across various sectors including oil and gas, transmission, power, mining, petrochemicals, refining, and more. We have a comprehensive experience of fabricating all types of modules including pipe-rack modules, process modules, skids, electrical e-houses, stair tower modules, structural modules, cable tray modules, building modules, and more.",

    supplyChainTitle: "Modular Supply Chain and HeviLift",
    supplyChainSubtitle: "Industrial Module Assembly Services",
    supplyChainDesc:
      "Golden M International can also offer a full suite of solutions between the pipe fabrication shop, the module yard and the field to optimize your entire module supply chain. Using our in-house HeviLift software, this optimization can set the best build order for your modules and coordinate their build, transportation, and storage to reduce your heavy lift schedule by upwards of 30 percent.",

    // Main Page - What We Build Section
    whatWeBuildMainTitle: "Building Excellence Across Industries",
    whatWeBuildMainDesc:
      "From concept to completion, we deliver exceptional results in every sector",
    projectTypes: "Project Types",
    commercialBuildings: "Commercial Buildings",
    infrastructureProjects: "Infrastructure Projects",
    industrialFacilities: "Industrial Facilities",
    residentialDevelopments: "Residential Developments",

    // Main Page - Safety Section
    safetyMainTitle: "Safety First, Always",
    safetyMainDesc:
      "Our commitment to safety is unwavering and integral to everything we do",
    zeroIncidents: "Zero Incident Goal",
    safetyTraining: "Comprehensive Safety Training",
    riskManagement: "Proactive Risk Management",

    ourLegacyTitle: "Our Legacy",
    buildingBetterFuture: "Building a Better Future",
    legacyParagraph:
      "Since 2015, Golden M International has been more than just a construction company — we've been a trusted partner in shaping skylines and strengthening communities across Portugal.",
    ourLegacyText:
      "Our legacy is built on a foundation of innovation, craftsmanship, and responsibility. From our early projects to our latest modular facilities, every structure we build tells a story of integrity and ambition. As we move forward, we remain committed to building not only for today — but for the generations to come.",

    coreValuesTitle: "Our Core Values",
    coreValuesSubtitle:
      "These values guide everything we do — from the smallest decisions to our biggest projects.",
    honestyTitle: "Honesty",
    honestyDesc:
      "We believe in transparency, truthfulness, and doing what’s right — even when no one is watching.",
    integrityTitle: "Integrity",
    integrityDesc:
      "We hold ourselves accountable and stay true to our commitments in every project we undertake.",
    respectTitle: "Respect",
    respectDesc:
      "We value people — our clients, partners, and team — and treat everyone with fairness and dignity.",
    innovationTitle: "Innovation",
    innovationDesc:
      "We embrace modern methods, creative thinking, and continuous improvement to lead in construction excellence.",

    // Main Page - Owners Section
    ownersTitle: "Employee-Owned, Client-Focused",
    ownersDesc:
      "As an employee-owned company, we are personally invested in your success",
    employeeOwnership: "100% Employee Ownership",
    clientSuccess: "Dedicated to Client Success",

    // Main Page - Who We Are Section
    whoWeAreMainTitle: "Who We Are",
    whoWeAreMainDesc: "A legacy of excellence in construction and engineering",
    ourValues: "Our Values",
    ourMission: "Our Mission",
    ourVision: "Our Vision",

    // Main Page - Where We Work Section
    whereWeWorkTitle: "Global Reach, Local Expertise",
    whereWeWorkDesc: "Serving clients across Portugal and beyond",
    globalProjects: "Global Projects",
    localPresence: "Local Presence",

    // Main Page - Collaboration Section
    collaborationTitle: "Building Together",
    collaborationDesc: "Success through partnership and teamwork",
    partnershipApproach: "Partnership Approach",
    teamworkValue: "Value of Teamwork",
    buildWithUsButton: "Build with Us",
    joinTeamButton: "Join Our Team",

    // Main Page - What We Do Section
    whatWeDoTitle: "Comprehensive Construction Solutions",
    whatWeDoDesc: "Full-service construction and engineering excellence",
    servicesOffered: "Services Offered",
    industryExpertise: "Industry Expertise",

    // Safety Page
    safetyPageTitle: "Safety Excellence",
    safetyPageDesc: "Our Commitment to Zero Incidents",
    safetyStats: "Safety Statistics",
    safetyPrograms: "Safety Programs",
    incidentPrevention: "Incident Prevention",
    safetyTrainingPrograms: "Safety Training Programs",

    // Preconstruction Page
    preconstructionTitle: "Preconstruction Services",
    preconstructionDesc: "Setting the Foundation for Project Success",
    costEstimation: "Cost Estimation",
    scheduleOptimization: "Schedule Optimization",
    valueEngineering: "Value Engineering",
    constructabilityReview: "Constructability Review",

    // Smart Construction Page
    smartConstructionTitle: "Smart Construction Solutions",
    smartConstructionDesc: "Leveraging Technology for Better Building",
    digitalTools: "Digital Tools",
    bimModeling: "BIM Modeling",
    projectManagementTech: "Project Management Technology",

    // Industrial Maintenance Page
    industrialMaintTitle: "Industrial Maintenance",
    industrialMaintDesc: "Keeping Your Operations Running Smoothly",
    preventiveMaintenance: "Preventive Maintenance",
    emergencyServices: "Emergency Services",
    facilityUpgrades: "Facility Upgrades",

    // Our Leaders Page
    leadersTitle: "Our Leadership Team",
    leadersDesc: "Guiding Excellence in Construction",
    executiveTeam: "Executive Team",
    seniorManagement: "Senior Management",
    boardOfDirectors: "Board of Directors",

    // Our History Page
    historyTitle: "Our Journey Through Time",
    historyDesc: "Building Excellence Since Day One",
    foundingYears: "Founding Years",
    growthExpansion: "Growth and Expansion",
    modernEra: "Modern Era",

    // Industrial ModPage Slides
    // industrialModslideTitle1: "Hassle-free Delivery",
    // industrialModSlideSubtitle1: "Industrial Module Assembly Services",
    // industrialModSlideDesc1:
    //   "Golden M International’s module assembly facilities are among the largest in Canada and ideally situated for heavy-haul transport across North America via truck or rail. Our in-house customs specialists will support and assist with module imports.",

    // industrialModslideTitle2: "Schedule Certainty",
    // industrialModSlideSubtitle2: "Industrial Module Assembly Services",
    // industrialModSlideDesc2:
    //   "Golden M International offers a complete solution that includes major procurement, bulk procurement, pipe fabrication self-directed modules assembly and management of subcontracted services. We can handle any size project and ensure on-time delivery due to our facility capacity and systematic production management.",

    // industrialModslideTitle3: "Modules for any Sector",
    // industrialModSlideSubtitle3: "Industrial Module Assembly Services",
    // industrialModSlideDesc3:
    //   "Golden M International has module assembly expertise across various sectors including oil and gas, transmission, power, mining, petrochemicals, refining, and more. We have a comprehensive experience of fabricating all types of modules including pipe-rack modules, process modules, skids, electrical e-houses, stair tower modules, structural modules, cable tray modules, building modules, and more.",

    // industrialModslideTitle4: "Modular Supply Chain and HeviLift",
    // industrialModSlideSubtitle4: "Industrial Module Assembly Services",
    // industrialModSlideDesc4:
    //   "Golden M International can also offer a full suite of solutions between the pipe fabrication shop, the module yard and the field to optimize your entire module supply chain. Using our in-house HeviLift software, this optimization can set the best build order for your modules and coordinate their build, transportation, and storage to reduce your heavy lift schedule by upwards of 30 percent.",

    // //Industrial Mod Header

    // industrialModCat: "INDUSTRIAL SERVICE",
    // // industrialModTitle: "Industrial Module Assembly ",
    // industrialModDesc: "Golden M International Industrial’s module assembly yard has made continuous improvement and lean construction the cornerstone of our success. We put 40 years of experience and expertise to work on your project.",
    innovationTitleVal: "Innovation",

    leadershipTeamTitle: "Our Leadership Team",
    leadershipTeamDesc:
      "At Golden M International, our leadership team brings decades of experience in construction, engineering, and project management. Based in Portugal, our leaders are committed to delivering innovative, sustainable, and client-focused solutions across every sector we serve. Their expertise drives our mission to build the future—one project at a time.",

    // Industrial Construction Services Page
    softwareStackTitle: "Construction Management Software Stack",
    constructionServicesByConstructors: "Construction Services by Constructors",
    softwareStackDesc:
      "Golden M International's construction management software stack, developed over the past decade, is a fully-integrated application suite that can be modularized and tailored to meet the lifecycle needs of any industrial construction project, with a focus on transitioning seamlessly from bulk area-based construction to system turnover and startup. The applications that comprise the stack run the gamut from estimating to costing to planning, packaging, inspection, completions and documentation.",

    modularApproachTitle: "A Modular Approach",
    modularApproachDesc:
      "Though the distinct individual applications in the stack can be used in isolation, they are best leveraged when configured to work in conjunction with each other. Whereas the estimating application can operate in isolation performing material labor take-off, for example, it can also be configured to speak to the work packaging and material control systems to perform specific work packaging and material requisition. Similarly, the document control system can run a direct line to completions.",

    showcase1Title: "Leading the Way",
    showcase1Desc:
      "We all contribute to the success of Golden M International’s safety program: the executives who instil a strong safety culture, the superintendent who leads the way, the project coordinator who helps trade partners understand our safety practices, the tradesperson who guides young apprentices, and so many more.",

    safetyHeading:
      "Our safety professionals strive to ensure everyone returns home safe at the end of the day.",

    safetyPara1:
      "Safety is at the core of everything we do and is one of our central guiding principles. We promote and foster a culture where people truly care about one another and where everyone shares in our goal of zero incidents.",

    safetyPara2:
      "Health, safety and environment focuses on uncompromised safety core values, personal commitment and a passionate belief in achieving zero injuries. We look to achieve this through frontline leadership, positive recognition, safe work behaviors, accountability at all levels and reducing exposure.",

    showcase2Title: "Safety Stats",
    showcase2Desc:
      "We maintain best in class industry safety with an average of more than 50 million hours worked annually and an overall total recordable incident rate and overall lost-time frequency rate, among the industry's lowest.",

    showcase3Title: "Continuous Improvement",
    showcase3Desc:
      "We recognize that our people are our most valuable asset, and we are dedicated to providing and maintaining a safe and healthy work environment for all. We’re continuously looking for innovative ways to improve our safety practices and to work with our trade partners to embrace a mindset that is unwilling to compromise when it comes to keeping people safe at work.",

    safetySectionTitle: "Safety at Golden M International",
    safetyQuote:
      "At Golden M International, safety isn’t just a requirement — it’s our responsibility. From blueprint to build, we protect every hand that shapes our vision.",
    quotePersonName: "Malik Arshad",
    quotePersonTitle: "CEO, Golden M International",

    costScheduleTitle: "Bringing Cost and Schedule Certainty",
    costScheduleDesc:
      "Ultimately, each of the stack applications, used separately or in concert, bring greater cost and schedule certainty, while also reducing the incredible manual effort needed to maintain documents and processes separately. By structuring the applications in a consistent manner, planning and ultimately construction execution is made more efficient.",

    stackCoreTitle: "The Stack and Core Processes",
    stackCoreDesc:
      "Golden M International's software stack contains more than sixty individual applications but is best understood by seeing them from the perspective of eight core processes which include estimating and costing; documents and engineering; materials and purchasing; planning and packaging; process and schedule; quality and completions; administration and human resources; and HSE.",

    industrialConstructionDesc:
      "We have been self-performing our work for decades and, in that time, we have built a considerable institutional memory. We've crystallized that knowledge into a stack of project management software that aids us our project teams from start to finish.",
    industrialInnovationTitle:
      "Innovative technologies help to lean processes and drive value to your bottom line.",
    industrialInnovationText:
      "Beyond adopting off-the-shelf technology, proactively partners with tech leaders to develop unique programs focused on resolving typical client pain points.",
    industrialInnovationLabel:
      "Industrial Construction Services AT Golden M International",

    lifecycleTitle: "Lifecycle Construction Management",
    lifecycleDesc:
      "With each project completed, we have learned, found efficiencies, obtained best practices and discovered new approaches. A considerable number of these developments have driven the development of an application-based software suite that we offer as tailorable solutions to our clients.",

    // Insights Page
    insightsTitle: "Industry Insights",
    insightsDesc: "Expert Perspectives on Construction",
    constructionTrends: "Construction Trends",
    industryAnalysis: "Industry Analysis",
    marketReports: "Market Reports",

    // Emergency Response Page
    emergencyTitle: "Emergency Response Services",
    emergencyDesc: "Ready When You Need Us Most",
    fullTimeService: "24/7 Service",
    rapidResponse: "Rapid Response",
    disasterRecovery: "Disaster Recovery",

    // Construction Page
    constructionTitle: "Construction Services",
    constructionDesc: "Building Your Vision",
    projectTypes: "Project Types",
    constructionMethods: "Construction Methods",
    qualityControl: "Quality Control",

    // Sustainable Services Page
    sustainableTitle: "Sustainable Construction",
    sustainableDesc: "Building for Tomorrow",
    greenBuilding: "Green Building",
    energyEfficiency: "Energy Efficiency",
    sustainableMaterials: "Sustainable Materials",

    // Prefabrication Page
    prefabTitle: "Prefabrication Services",
    prefabDesc: "Innovation in Construction",
    modularConstruction: "Modular Construction",
    offSiteManufacturing: "Off-Site Manufacturing",
    qualityAssurance: "Quality Assurance",

    // Services Components - Slider
    sliderPrevious: "Previous",
    sliderNext: "Next",
    viewDetails: "View Details",
    projectGallery: "Project Gallery",

    // Services Components - Smart Construction Header
    smartConsTitle: "Smart Construction Technologies",
    smartConsSubtitle: "Transforming Construction Through Innovation",
    digitalSolutions: "Digital Solutions",
    projectEfficiency: "Project Efficiency",
    dataAnalytics: "Data Analytics",

    // Services Components - Showcase
    showcaseTitle: "Featured Projects",
    showcaseDesc: "Excellence in Every Project",
    viewAllProjects: "View All Projects",
    projectDetails: "Project Details",

    // Services Components - Commitments
    commitmentsTitle: "Our Commitments",
    commitmentsDesc: "Building Trust Through Excellence",
    safetyFirst: "Safety First",
    qualityAssurance: "Quality Assurance",
    clientSatisfaction: "Client Satisfaction",

    // Budget Components - Construction Efficiency
    constEffTitle: "Construction Efficiency",
    constEffDesc: "Optimizing Every Phase of Construction",
    costOptimization: "Cost Optimization",
    timeManagement: "Time Management",
    resourceAllocation: "Resource Allocation",

    // Budget Components - Construction Header
    budgetTitle: "Budget and Planning",
    budgetDesc: "Strategic Financial Planning for Construction",
    costEstimation: "Cost Estimation",
    budgetControl: "Budget Control",
    financialPlanning: "Financial Planning",

    // Newsroom Components
    latestNews: "Latest News",
    pressReleases: "Press Releases",
    mediaContact: "Media Contact",
    newsArchive: "News Archive",
    subscribeNews: "Subscribe to News",

    // Article Components
    readMore: "Read More",
    publishDate: "Publish Date",
    author: "Author",
    category: "Category",
    shareArticle: "Share Article",

    // Insights Components
    insightsLatest: "Latest Insights",
    thoughtLeadership: "Thought Leadership",
    marketTrends: "Market Trends",
    industryNews: "Industry News",
    filterBy: "Filter By",
    sortBy: "Sort By",
    readTime: "Read Time",
    shareInsight: "Share Insight",
    relatedTopics: "Related Topics",

    // Our Location Components
    officesTitle: "Our Offices",
    officeHeading: " Golden M International has offices across Portugal",
    officeDesc:
      "Golden M International maintains a strategic presence throughout Portugal, with offices in major cities and regional centers. Our network enables us to deliver exceptional construction and engineering services nationwide, combining local expertise with global standards to meet the unique needs of each region.",
    // officesDesc: "Global Presence, Local Excellence",
    findOffice: "Find an Office",
    contactOffice: "Contact Office",
    directions: "Get Directions",
    officeHours: "Office Hours",

    // Our Work Components
    projectsTitle: "Our Projects",
    projectsDesc: "Building Excellence Across Sectors",
    filterProjects: "Filter Projects",
    projectLocation: "Project Location",
    projectValue: "Project Value",
    completionDate: "Completion Date",
    clientName: "Client",
    projectScope: "Project Scope",

    ourWorkTitle: "OUR WORK",
    ourWorkHeading:
      "Building the future of the construction industry, one project at a time",

    // Project Slider
    previousProject: "Previous Project",
    nextProject: "Next Project",
    viewProject: "View Project",
    allProjects: "All Projects",
    featuredProjects: "Featured Projects",

    // About Us Page Components
    missionStatement: "Mission Statement",
    companyValues: "Company Values",
    ourTeam: "Our Team",
    companyHistory: "Company History",

    // About Us - By The Numbers
    yearsExperience: "Years of Experience",
    completedProjects: "Completed Projects",
    activeProjects: "Active Projects",
    satisfiedClients: "Satisfied Clients",

    // About Us - How We Show Up
    innovation: "Innovation",
    excellence: "Excellence",
    integrity: "Integrity",
    sustainability: "Sustainability",

    // About Us - Commitments
    safetyCommitment: "Safety Commitment",
    qualityCommitment: "Quality Commitment",
    environmentCommitment: "Environmental Commitment",
    communityCommitment: "Community Commitment",

    // Industrial Modular Page
    modularTitle: "Industrial Modular Construction",
    modularDesc: "Advanced Modular Solutions for Industry",
    modularBenefits: "Benefits of Modular",
    modularProcess: "Modular Process",
    modularApplications: "Applications",

    // Industrial Construction Services
    industrialConsTitle: "Industrial Construction Services",
    industrialConsDesc: "Comprehensive Industrial Solutions",
    processIndustries: "Process Industries",
    powerGeneration: "Power Generation",
    manufacturingFacilities: "Manufacturing Facilities",

    // Self Perform Page
    selfPerformTitle: "Self-Perform Capabilities",
    selfPerformDesc: "Quality Control Through Direct Execution",
    inHouseExpertise: "In-House Expertise",
    qualityControl: "Quality Control",
    costEfficiency: "Cost Efficiency",

    // Emergency Services Page
    emergencyServTitle: "Emergency Construction Services",
    emergencyServDesc: "Rapid Response When You Need It Most",
    disasterRecovery: "Disaster Recovery",
    emergencyRepair: "Emergency Repair",
    crisisManagement: "Crisis Management",

    // Construction Services Page
    constructionServiceCategory: "BUILDING SERVICE",
    constructionServiceTitle: "Construction Services",
    constructionServiceDesc:
      "Our suite of integrated construction services ensure the highest degree of quality, safety, efficiency and innovation on your projects.",
    constructionInnovationTitle:
      "Delivering integrated construction services to build lasting success",
    constructionInnovationText:
      "When you partner with Golden M International, you not only get innovative solutions, you get our fully vested team and a commitment to doing things right. Our relentless focus on success leads to smarter more collaborative building practices.",

    // Construction Services Slides
    pushingIndustryTitle: "Pushing the Industry Forward",
    servicesSuccessSubtitle: "Services for Your Success",
    pushingIndustryDesc:
      "At Golden M International, we are passionate about driving value into every project we undertake. We continue to challenge our people, projects and the industry. By being forward-thinking, we are continually finding new ways to deliver success for our clients and stakeholders.",

    qualityAssuranceTitle: "Quality Assurance",
    qualityAssuranceDesc:
      "Golden M International's culture of quality is built into everything we do and begins with personal accountability from our employee-owners. Successful quality projects demonstrate our culture that embraces clear communication, strong problem-solving, and a relentless focus on creating strong relationships. We work with you from project start-up through completion to ensure your expectations are delivered and the final project meets all your needs.",

    leanConstructionTitle: "Lean Design & Construction",
    leanConstructionDesc:
      "Our team of construction experts are passionate about incorporating Lean practices into our projects while delivering unsurpassed value with the least amount of waste by ensuring flow efficiency in everything we do. One way we incorporate Lean principles is through the Last Planner® System, the planning and scheduling technique designed to foster true collaboration, awareness and successful execution for your project.",

    projectTrendsTitle: "Tracking Project Trends",
    projectTrendsDesc:
      "From smart sensors to comprehensive integrated project analytics, we track and trend progress, quality, safety and more. This data allows us to understand the immediate and potential impacts of items and provides a simple means of examining complex data, provide you with options, and resolve challenges before they become issues.",

    // What We Do 2 Section
    learnMoreAction: "LEARN MORE",

    // Portuguese translations
    // ... existing code ...

    // Construction Services Page

    // ... existing code ...

    // Preconstruction Page
    preconsServiceCategory: "Buildings and Civil Service",
    preconsServiceTitle: "Enhanced Preconstruction Services",
    preconsServiceDesc:
      "With early engagement of Golden M International subject matter experts and advanced value-added services, Preconstruction is a critical opportunity to set the stage for success. Focused on design, schedule and budget optimization, Golden M International drives value to your bottom line.",
    preconsOverviewTitle: "SERVICE OVERVIEW",
    preconsInnovationTitle:
      "Expert-optimized design solutions save time/cost through quality contract documents",
    preconsInnovationText:
      "Through integrated constructability and value engineering reviews, our multi-disciplinary experts ensure quality design documents that secure best pricing from trades bidding on clear scopes with reduced risk of costly change orders due to redesign.",
    preconsInnovationLabel:
      "Enhanced Preconstruction Services AT Golden M International",

    // Preconstruction Slides
    targetValueTitle: "Target Value Design",
    targetValueSubtitle: "The Value of Preconstruction",
    targetValueDesc:
      "Based on Lean principles, integrated teams gain collective insight into the client's true value drivers and uses a set based design approach to evaluate design options against target values. In the end, the owner benefits from maximized value; the architect benefits from a more informed design; the GC benefits from greater cost/risk certainty; and the trades and sub-consultants benefit from early engagement and accountability for processes.",

    buildingSystemsOptTitle: "Building Systems Design Optimization",
    buildingSystemsOptSubtitle: "Building Systems Design Optimization",
    buildingSystemsOptDesc:
      "As design builder, we own the risk for both design and construction of your project, based on prescribed Project-Specific Output Specifications. DB is highly collaborative as the full project team comes together early in design. Combined expertise drives value to design and construction outcomes, effectively mitigating the risk of scope and cost escalation. DB ensures cost effective, quality facilities typically delivered on reduced schedules as construction can begin prior to design completion.",

    envelopeOptTitle: "Building Envelope Design Optimization",
    envelopeOptSubtitle: "The Value of Preconstruction",
    envelopeOptDesc:
      "Optimal building envelope systems and materials maximize building performance and sustainability. Golden M International preconstruction teams have technical expertise to support design and construction, identifying material, constructability, and sequencing of building installation and offers solutions for achieving LEED credits and improved building performance and maintenance.",

    verticalTransportTitle: "Vertical Transportation Design Optimization",
    verticalTransportSubtitle: "The Value of Preconstruction",
    verticalTransportDesc:
      "Our teams drive value by optimizing all facets of vertical transportation design in facilities of all types, new or revitalized. From capital planning, specifications, tendering and bid assessment to procurement due diligence and project management to equipment audits, upgrading, modernizations, and replacements, our expertise through preconstruction design review puts money back into the budget, guaranteed!",
  },
  pt: {
    // Navigation
    services: "Serviços",
    ourWork: "Nosso Trabalho",
    locations: "Localizações",
    whoWeAre: "Quem Somos",
    insights: "Insights",
    newsroom: "Sala de Imprensa",
    careers: "Carreiras",
    search: "Buscar",

    ownersSectionTitle: "PROPRIEDADE DOS FUNCIONÁRIOS",
    ownersSectionDesc:
      "Construindo Sucesso Através da Propriedade Compartilhada",
    employeeOwnership: "100% Propriedade dos Funcionários",
    ownershipBenefits:
      "Como funcionários-proprietários, estamos pessoalmente investidos no sucesso de cada projeto e na satisfação de cada cliente.",
    ownershipCulture: "Cultura de Propriedade",
    ownershipDesc:
      "Nossa cultura de propriedade impulsiona a inovação, a excelência e um profundo compromisso com a entrega de resultados excepcionais.",
    joinOurTeam: "JUNTE-SE À NOSSA EQUIPE",
    learnMore: "SAIBA MAIS",
    presidentPortrait: "Retrato do Presidente",

    // Services Dropdown
    buildings: "Edifícios",
    civil: "Civil",
    industrial: "Industrial",
    servicesTitle: "SERVIÇOS",
    constructabilityBudget: "Construtibilidade e Controle de Orçamento",
    smartConstruction: "Construção Inteligente",
    prefabModular: "Pré-fabricação e Construção Modular",
    sustainableConstruction: "Serviços de Construção Sustentável",
    constructionServices: "Serviços de Construção",
    emergencyResponse: "Resposta de Emergência",
    selfPerform: "Capacidades de Auto-Execução",
    deliveryMethods: "Métodos de Entrega",
    preconstructionServices: "Serviços de Pré-construção",
    specialProjects: "Projetos Especiais",

    // Industrial Services
    industrialConstructionServices: "Serviços de Construção Industrial",
    industrialConstructionEngineering: "Engenharia de Construção Industrial",
    industrialModular: "Construção Modular Industrial",
    industrialSiteExecution: "Execução de Site Industrial",
    peopleTeams: "Pessoas, Equipes e Soluções de Mão de Obra Especializada",
    maintenance: "Manutenção Industrial e Reforma",

    // What We Do 2 Section
    learnMoreAction: "SABER MAIS",

    // Who We Are Dropdown
    whoWeAreTitle: "QUEM SOMOS",
    leadership: "Liderança",
    innovation: "Inovação",
    safety: "Segurança",
    aboutUs: "Sobre a Golden M International",
    ourHistory: "Nossa História",
    ourLeadership: "Nossa Liderança",
    aboutUsDescription:
      "Trabalhar conosco significa que você tem nossa rede de mais de 5.200 especialistas ao seu lado.",
    historyDescription:
      "De raízes humildes em pequenas cidades, a Golden M International tornou-se líder internacional em construção.",
    leadershipDescription:
      "Conheça nossa equipe de liderança que orienta as operações estratégicas em toda a nossa empresa.",
    innovationDescription:
      "Estamos apaixonadamente liderando o caminho na digitalização da indústria da construção.",
    safetyDescription:
      "Criar um ambiente de trabalho seguro e saudável é um princípio orientador central.",

    // Home Page
    whatWeBuildTitle: "O QUE CONSTRUÍMOS",
    whatWeBuildSubtitle:
      "Olhamos além das suas necessidades imediatas de construção para desenvolver soluções abrangentes para cada projeto",
    projectShowcase: "MOSTRA DE PROJETOS",
    location: "LOCALIZAÇÃO:",
    market: "MERCADO:",

    // Project Descriptions
    // uclaProject: "O projeto das residências Olympic e Centennial para UCLA abrange 371.000 pés quadrados, consistindo em dez andares acima do solo e um porão de manutenção de 1.000 pés quadrados. O planejamento cuidadoso garantiu serviço contínuo para estudantes e funcionários, preservando as características naturais do local e minimizando a interrupção da construção.",
    // urbanProject: "Este projeto abrangente de renovação de infraestrutura urbana engloba melhorias importantes em estradas, atualizações de serviços públicos e implementação de sistemas sustentáveis de gestão de águas pluviais em um corredor de 25 milhas, melhorando a conectividade enquanto minimiza o impacto ambiental.",
    // manufacturingProject: "Nossa instalação de fabricação de 450.000 pés quadrados de última geração apresenta métodos inovadores de construção modular, reduzindo o tempo de construção em 30% enquanto incorpora sistemas de energia renovável que fornecem 40% das necessidades de energia da instalação.",
    // coastalProject: "Esta instalação de pesquisa especializada exigiu soluções de engenharia inovadoras para suportar condições costeiras extremas, fornecendo espaços de laboratório de última geração para cientistas marinhos e recursos de design sustentáveis que alcançaram a certificação LEED Platinum.",

    // Markets
    education: "EDUCAÇÃO",
    infrastructure: "INFRAESTRUTURA",
    manufacturing: "FABRICAÇÃO",
    research: "PESQUISA",

    // Footer
    contactUs: "Contate-nos",
    ethicsCode: "Ética/Código de Conduta",
    hourlyEmployee: "Informações de Funcionários Horistas",
    privacyPolicy: "Política de Privacidade & Marcas Registradas",
    toolsResources: "Ferramentas & Recursos",
    copyright: "Copyright © 2025 Golden M International Inc",
    allRightsReserved: "Todos os direitos reservados",
    privacyPolicyLink:
      "https://www.Golden M International.com/us/en/privacy-policy",
    followUs: "Siga-nos",
    termsOfUse: "Termos de Uso",

    // Service Category Descriptions
    buildingsDescription:
      "De métodos de entrega P3s e EPC a serviços de pré-construção, estamos prontos para atender às suas necessidades.",
    civilDescription:
      "Nossa experiência em construção civil abrange projetos de infraestrutura, transporte e engenharia civil pesada em todo o país.",
    industrialDescription:
      "Entregamos projetos industriais complexos com foco em segurança, qualidade e excelência operacional.",

    // Careers Page
    buildCareer: "Construa Sua Carreira Conosco",
    careerHeroText:
      "Junte-se à Golden M International e faça parte de uma equipe que está moldando o futuro da construção e engenharia em Portugal.",
    applyNow: "Inscreva-se Agora",
    whyWorkWithUs: "Por Que Trabalhar Conosco",

    //Our History
    historyEvent1Title: "Inícios Humildes",
    historyEvent1Desc:
      "Em 2015, a empresa foi fundada por uma pequena equipa de visionários determinada a transformar o setor da construção com qualidade, fiabilidade e inovação.",
    historyEvent1Alt: "Estaleiro de construção em desenvolvimento inicial",

    historyEvent2Title: "Primeira Grande Conquista",
    historyEvent2Desc:
      "Em 2018, a empresa concluiu o seu primeiro grande projeto comercial, ganhando confiança na região e expandindo as suas operações.",
    historyEvent2Alt: "Edifício comercial concluído",

    historyEvent3Title: "Novos Territórios",
    historyEvent3Desc:
      "O ano de 2022 marcou a entrada na construção modular e pré-fabricada. Os investimentos em DfMA e práticas de construção Lean revolucionaram o processo de entrega.",
    historyEvent3Alt: "Trabalhadores a instalar componentes modulares no local",

    historyEvent4Title: "Inovação em Escala",
    historyEvent4Desc:
      "Em 2024, a empresa expandiu os seus serviços modulares por todo o país, ganhando contratos nacionais e parcerias no setor público e privado.",
    historyEvent4Alt: "Grande edifício modular em montagem",

    historyEvent5Title: "A Construir o Futuro Hoje",
    historyEvent5Desc:
      "Atualmente, a empresa lidera na construção modular sustentável — orientada por um propósito, impulsionada pela tecnologia e focada no impacto comunitário.",
    historyEvent5Alt: "Instalação modular moderna com painéis solares",

    ourHistoryTitle: "A Nossa História",

    // Career Benefits
    collaborativeCulture: "Cultura Colaborativa",
    collaborativeCultureDesc:
      "Junte-se a uma equipe que valoriza sua contribuição e promove colaboração em todos os níveis.",
    careerGrowth: "Crescimento na Carreira",
    careerGrowthDesc:
      "Caminhos claros para o avanço com mentoria e oportunidades de desenvolvimento profissional.",
    competitiveBenefits: "Benefícios Competitivos",
    competitiveBenefitsDesc:
      "Assistência médica abrangente, planos de aposentadoria e iniciativas de equilíbrio entre vida pessoal e profissional.",
    impactfulProjects: "Projetos Impactantes",
    impactfulProjectsDesc:
      "Trabalhe em projetos significativos que moldam comunidades e definem horizontes em Portugal.",

    // Open Positions
    openPositions: "Posições Abertas",
    seniorProjectManager: "Gerente de Projeto Sênior",
    civilEngineer: "Engenheiro Civil",
    architecturalDesigner: "Designer Arquitetônico",
    constructionSupervisor: "Supervisor de Construção",
    fullTime: "Tempo integral",
    noPositionFit: "Não vê uma posição que se encaixe nas suas habilidades?",
    submitGeneral: "Enviar uma Aplicação Geral",

    ourHistorySubtitle: "Vamos percorrer a história da nossa empresa",
    ourStoryTitle: "Nossa História",
    ourStoryParagraph1:
      "Fundada em 2015, a Golden M International nasceu com uma visão clara — revolucionar a indústria da construção com qualidade, inovação e confiança. O que começou com uma pequena equipa e grandes sonhos rapidamente se transformou num dos parceiros de construção mais fiáveis de Portugal, reconhecido pelo compromisso com a excelência e a abordagem centrada no cliente.",
    ourStoryParagraph2:
      "Desde a entrega de edifícios modulares até à execução de projetos de resposta a emergências, crescemos adotando tecnologias de ponta e métodos sustentáveis. A nossa jornada sempre foi impulsionada por pessoas — as nossas equipas apaixonadas, os clientes fiéis e as comunidades que servimos. Hoje, continuamos a construir não apenas estruturas, mas um legado de resiliência, precisão e propósito.",
    innovationTitleVal: "Inovação",

    // Construction Services Page
    constructionServiceCategory: "SERVIÇO DE CONSTRUÇÃO",
    constructionServiceTitle: "Serviços de Construção",
    constructionServiceDesc:
      "Nossa suíte de serviços integrados de construção garante o mais alto grau de qualidade, segurança, eficiência e inovação em seus projetos.",
    constructionInnovationTitle:
      "Entregando serviços integrados de construção para construir sucesso duradouro",
    constructionInnovationText:
      "Quando você se associa à Golden M International, você não apenas obtém soluções inovadoras, mas também nossa equipe totalmente comprometida e um compromisso em fazer as coisas corretamente. Nosso foco incansável no sucesso leva a práticas de construção mais inteligentes e colaborativas.",
    serviceOverview: "VISÃO GERAL DO SERVIÇO",
    sustainableConstructionServices:
      "Serviços de Construção Sustentável na Golden M International",

    historyQuote:
      "Construindo um legado de excelência, um projeto de cada vez.",
    ceoQuote: "Malik Arshad, CEO da Golden M International",

    // Construction Services Slides
    pushingIndustryTitle: "Impulsionando a Indústria Adiante",
    servicesSuccessSubtitle: "Serviços para Seu Sucesso",
    pushingIndustryDesc:
      "Na Golden M International, somos apaixonados por agregar valor a cada projeto que realizamos. Continuamos a desafiar nossas pessoas, projetos e a indústria. Sendo visionários, estamos continuamente encontrando novas maneiras de entregar sucesso para nossos clientes e partes interessadas.",

    qualityAssuranceTitle: "Garantia de Qualidade",
    qualityAssuranceDesc:
      "A cultura de qualidade da Golden M International está incorporada em tudo o que fazemos e começa com a responsabilidade pessoal de nossos funcionários-proprietários. Projetos de qualidade bem-sucedidos demonstram nossa cultura que abraça comunicação clara, forte resolução de problemas e um foco incansável na criação de relacionamentos fortes. Trabalhamos com você desde o início do projeto até a conclusão para garantir que suas expectativas sejam atendidas e o projeto final atenda a todas as suas necessidades.",

    ourLegacyTitle: "O Nosso Legado",
    buildingBetterFuture: "Construindo um Futuro Melhor",
    legacyParagraph:
      "Desde 2015, a Golden M International tem sido mais do que uma empresa de construção — somos um parceiro de confiança na transformação de skylines e no fortalecimento de comunidades em todo Portugal.",
    ourLegacyText:
      "O nosso legado é construído sobre inovação, excelência e responsabilidade. Desde os primeiros projetos até as mais recentes instalações modulares, cada estrutura que erguemos conta uma história de integridade e ambição. À medida que avançamos, mantemos o compromisso de construir não apenas para hoje — mas para as gerações futuras.",

    leanConstructionTitle: "Design e Construção Enxuta",
    leanConstructionDesc:
      "Nossa equipe de especialistas em construção é apaixonada por incorporar práticas Lean em nossos projetos, entregando valor insuperável com o mínimo de desperdício, garantindo eficiência de fluxo em tudo o que fazemos. Uma maneira de incorporarmos os princípios Lean é através do Sistema Last Planner®, a técnica de planejamento e programação projetada para promover verdadeira colaboração, consciência e execução bem-sucedida para seu projeto.",

    projectTrendsTitle: "Acompanhamento de Tendências de Projetos",
    projectTrendsDesc:
      "De sensores inteligentes a análises abrangentes de projetos integrados, rastreamos e acompanhamos progresso, qualidade, segurança e muito mais. Esses dados nos permitem entender os impactos imediatos e potenciais dos itens e fornecem um meio simples de examinar dados complexos, fornecer opções e resolver desafios antes que se tornem problemas.",

    // Main Page - What We Do 2 Section
    whatWeDo2Title: "O QUE FAZEMOS",
    whatWeDo2Subtitle: "Experiência em Diversos Mercados",
    buildingsTabTitle: "Edifícios",
    buildingsTabHeading: "Arquitetura Moderna para Necessidades Contemporâneas",
    buildingsTabDesc:
      "Nos especializamos em criar soluções inovadoras de construção que combinam estética com funcionalidade. Nossos edifícios são projetados com sustentabilidade e eficiência em mente, garantindo que atendam às necessidades de hoje enquanto estão preparados para os desafios de amanhã.",

    civilInfraTabTitle: "Infraestrutura Civil",
    civilInfraTabHeading: "Construindo a Base da Sociedade",
    civilInfraTabDesc:
      "Nossos projetos de infraestrutura conectam comunidades e impulsionam economias. De estradas e pontes a sistemas de água e redes de energia, entregamos soluções robustas que resistem ao teste do tempo enquanto minimizam o impacto ambiental.",

    //Pre Fab Slides
    modularComponentsTitle:
      "Abordagem de Componentes Modulares 'Kit de Peças': Flexível e Familiar",
    ourApproach: "A Nossa Abordagem",
    modularComponentsDesc:
      "Elementos-chave da construção são pré-fabricados e enviados para o local para serem montados na estrutura. O Kit de Peças pode incluir: elementos de núcleo pré-moldados, escadas e poços de elevador, paredes estruturais interiores/exteriores com função de suporte de carga, paredes interiores não estruturais, casas de banho pré-fabricadas e salas técnicas/mecânicas e elétricas. Esta abordagem exige menos trabalho de conceção inicial para libertar componentes específicos para fabrico e utiliza materiais e métodos de construção amplamente conhecidos pelos profissionais.",
    viewSelfPerform: "VER OS NOSSOS SERVIÇOS DE EXECUÇÃO PRÓPRIA",
    teamCollaborating:
      "Equipa a colaborar numa sala de reuniões com projetos de edifícios nos ecrãs",

    volumetricApproachTitle:
      "Abordagem Volumétrica Total: Montagem no Local como 'Blocos de Lego'",
    volumetricApproachDesc:
      "A construção modular volumétrica total é um processo em que grandes módulos de edifícios são fabricados fora do local e depois montados no local como blocos de Lego para criar a estrutura e um edifício quase finalizado. Com a maior parte da 'construção' a ocorrer numa instalação, esta abordagem pode reduzir até 90% do desperdício no local, enquanto o processo de fabrico e montagem gera menos de 0,6% de resíduos para aterro. A modelação e resolução integrada e precoce do projeto antes da produção dos módulos é fundamental.",

    dfmaTitle:
      "Design para Fabrico e Montagem (DfMA): Uma Metodologia de Engenharia",
    dfmaDesc:
      "O DfMA acelera a produção e reduz os custos ao garantir tanto a facilidade de fabrico dos componentes modulares quanto a montagem simplificada desses componentes no módulo final — tudo isso na fase inicial e iterativa do design do projeto. Trabalhando com tecnologias BIM avançadas, os nossos especialistas em design modular e engenheiros de processo obtêm matérias-primas económicas e otimizam os processos de fabrico e montagem modular para reduzir mão-de-obra, tempo, custos e complexidade.",
    innovativeTechniques:
      "Técnicas de construção inovadoras a serem implementadas no local",

    lessonsLearnedTitle:
      "Mais de 30 Anos em Construção Modular: Lições Aprendidas",
    lessonsLearnedDesc:
      "A Golden M International percorreu o desafiante caminho da construção modular e, após ter entregue desde plenums de AVAC pré-fabricados a casas de banho completas, centros de dados volumétricos, escritórios de obra e até uma biblioteca pública, traz uma vasta experiência de Lições Aprendidas e Melhores Práticas. Garantimos que os nossos clientes beneficiem de um know-how baseado na experiência para avaliar riscos e tomar as decisões e soluções certas para atingir os seus objetivos.",

    heavyIndTabTitle: "Industrial Pesado",
    heavyIndTabHeading: "Impulsionando o Progresso Industrial",
    heavyIndTabDesc:
      "Temos ampla experiência na construção de instalações industriais complexas que requerem conhecimento especializado e precisão. Nossos projetos industriais apoiam manufatura, geração de energia e processamento de recursos com ênfase em segurança e eficiência operacional.",

    specialProjTabTitle: "Projetos Especiais",
    specialProjTabHeading: "Soluções Únicas para Necessidades Especializadas",
    specialProjTabDesc:
      "O melhor dos dois mundos: o compromisso, a capacidade de resposta e a qualidade de um empreiteiro local, juntamente com a experiência, o conhecimento e a cultura de segurança de uma grande organização de contratação. Usando uma abordagem prática e individualizada em Projetos Especiais, a precisão consistentemente entrega resultados excepcionais para clientes novos e recorrentes.",

    // Self Perform Page
    selfPerformTitle: "Capacidades de Execução Própria",
    selfPerformDesc:
      "Trazemos uma mentalidade de construtor para todo o nosso trabalho. A nossa equipa aprende o negócio desde a base em diversos tipos de projetos e gera valor através da criação de eficiências de custo, previsibilidade nos prazos e flexibilidade em todos os nossos projetos.",
    serviceOverview: "VISÃO GERAL DO SERVIÇO",
    selfPerformServicesTitle:
      "Serviços de execução própria que trabalham para si",
    selfPerformServicesDesc:
      "A nossa força de trabalho possui anos de experiência prática, formação e desenvolvimento de competências no terreno. As nossas equipas aplicam o seu profundo conhecimento da construção para entregar um trabalho excecional.",
    sustainableConstructionServices:
      "Serviços de Construção Sustentável na Golden M International",

    // Commitments Self-Perform
    selfPerformCapabilities: "Capacidades de Execução Própria",
    selfPerformQuote:
      "Como empresa de construção em Portugal, as nossas capacidades de execução própria são a nossa espinha dorsal — desde os trabalhos de base até aos acabamentos, executamos todas as fases com as nossas próprias equipas especializadas. É assim que garantimos qualidade, responsabilidade e entrega pontual, sempre.",
    ceoName: "Malik Arshad",
    ceoTitle: "CEO, Golden M International",

    // self perform Slides
    selfPerformSuccessTitle: "Sucesso Comprovado na Execução Própria",
    selfPerformSuccessDesc:
      "Como um dos principais empreiteiros gerais em Portugal, somos guiados pela experiência de sermos construtores acima de tudo. Temos capacidade para executar diretamente, com contratação própria de mão de obra e supervisão de vários tipos de trabalhos com diferentes níveis de complexidade — desde a logística do local e escavações até à demolição seletiva e betão finalizado. Aproveitamos uma força de trabalho qualificada que se adapta às necessidades do seu projeto.",
    viewSelfPerformServices: "VER OS NOSSOS SERVIÇOS DE EXECUÇÃO PRÓPRIA",

    selfPerformAdvantagesTitle: "Vantagens da Execução Própria",
    selfPerformAdvantagesDesc:
      "A execução própria dos trabalhos de construção oferece inúmeros benefícios, incluindo poupança de custos, maior controlo de qualidade e cumprimento rigoroso dos prazos. Ao gerir internamente todo o processo de construção, conseguimos garantir que cada projeto é concluído com os mais altos padrões de qualidade, dentro do prazo e do orçamento.",

    // Main Page - Owners Section
    ownersTitle: "Propriedade dos Funcionários, Foco no Cliente",
    ownersDesc:
      "Como uma empresa de propriedade dos funcionários, estamos pessoalmente investidos em seu sucesso",
    clientSuccess: "Dedicados ao Sucesso do Cliente",

    // Image Alt Texts
    serviceIllustration: "Ilustração de serviço",
    featureImage: "Imagem destaque",
    teamCollaborating:
      "Equipe colaborando em uma sala de reuniões com projetos de construção nas telas",
    teamWorking: "Equipe trabalhando no processo de design de valor alvo",

    slide: "Slide",
    companyLogo: "Logo da Golden M International Construction",
    cityscape: "Panorama de Lisboa com o rio Tejo e edifícios",
    architecturalVisualization: "Visualização 3D de estrutura arquitetônica",
    constructionBlueprint: "Visualização complexa do projeto de construção",
    projectAnnouncement: "Anúncio de novo projeto",
    awardCeremony: "Cerimônia de premiação",
    industryConference: "Conferência da indústria",
    digitalConstruction: "Construção digital",
    industrialEquipment: "Equipamento industrial avançado",
    constructionWorker:
      "Trabalhador da construção com equipamento de segurança",
    solarPanels: "Painéis solares em edifício",
    recycledMaterials: "Materiais de construção reciclados",
    communityOutreach: "Programa de divulgação comunitária",
    teamBuilding: "Evento de formação de equipe",
    marketAnalysis: "Gráfico de análise de mercado",
    urbanDevelopment: "Projeto de desenvolvimento urbano",
    presidentPortrait: "Malik Arshad - Presidente e Gerente Geral",
    safetyOnSite:
      "Trabalhadores da construção com equipamento de segurança no local",

    // Common Actions
    viewMore: "Ver Mais",
    contactNow: "Contate Agora",
    learnMoreCta: "SAIBA MAIS",

    // Accessibility Labels
    searchButton: "Botão de busca",
    languageSelector: "Seletor de idioma",
    menuButton: "Botão de menu",
    closeButton: "Botão de fechar",

    // Service Descriptions
    smartConstructionDesc:
      "Nossas soluções de construção inteligente aproveitam tecnologia de ponta para melhorar a eficiência e os resultados do projeto.",
    maintenanceDesc:
      "Serviços abrangentes de manutenção industrial e reforma para otimizar o desempenho das instalações e minimizar o tempo de inatividade.",

    // Showcase Sections
    showcaseTitle1: "Soluções Inovadoras",
    showcaseDesc1:
      "Liderando a indústria com metodologias e tecnologias avançadas de construção.",
    showcaseTitle2: "Práticas Sustentáveis",
    showcaseDesc2:
      "Implementando práticas de construção ecológicas para um amanhã melhor.",

    // Construction Efficiency
    constructionEfficiencyTitle:
      "Maximizar a eficiência de design e construção desde o início agrega valor mensurável e reduz riscos.",

    // Safety Section
    safetyTitle: "Segurança: Um Estilo de Vida",
    safetyText:
      "Nossa cultura de segurança é uma que se estende além do local de trabalho para garantir que todos retornem para casa com segurança todos os dias.",
    safetyLearnMore: "SAIBA MAIS",

    // Smart Construction Slides
    floodProtectionTitle:
      "Proteção Contra Inundações e Economia em Seguros com Soluções Eddy",
    floodProtectionSubtitle: "O VALOR DA PRÉ-CONSTRUÇÃO",
    floodProtectionDesc:
      "Inundações e danos causados pela água são riscos caros para edificações. É por isso que a Golden M International fez parceria com a Eddy Solutions para integrar as tecnologias de monitoramento inteligente de água e mitigação de vazamentos da Eddy no Job Site Insights™. Com a Eddy, o JSI™ pode monitorar, controlar e conservar o uso de água, protegendo um edifício e sistemas críticos contra o risco de danos causados pela água durante a construção. Reduza seus prêmios de seguro e proteja seus ativos construídos durante e após a construção com a Golden M International.",

    deRiskingTitle:
      "Reduzindo Riscos em Projetos com Job Site Insights™, a Plataforma IoT Inteligente",
    deRiskingSubtitle: "Inovações Comprovadas",
    deRiskingDesc:
      "JSI™ é uma plataforma de construção inteligente baseada em nuvem que fornece monitoramento de tendências de problemas potenciais em nossos projetos através de sensores que monitoram e medem temperatura, umidade, água/inundação, vibração e som. Envolvido em mais de 63 projetos, o JSI™ cria um modelo de rastreamento de sensores em tempo real acessível de qualquer dispositivo. Os insights obtidos do JSI™ reduzem o uso de energia, retrabalho e custos de seguro, enquanto os dados são armazenados para análises futuras.",

    innovativeMethodsTitle: "Métodos de Construção Inovadores",
    innovativeMethodsDesc:
      "A plataforma de dados e análises de energia da CopperTree transforma dados brutos de sistemas de automação predial e mecânicos em insights acionáveis que melhoram o comissionamento e o gerenciamento de edifícios. A CopperTree lê todos os pontos de dados dos sistemas de gerenciamento de edifícios e pode ser usada para fornecer análises profundas de todos os sistemas mecânicos em relação às especificações de design. Armados com dados acionáveis, os gerentes de edifícios podem tomar decisões informadas e estratégicas para reduzir o consumo de energia, direcionar esforços de manutenção e aumentar a eficiência. A CopperTree continua a entregar valor aos clientes como parte do fluxo de trabalho operacional de um edifício.",

    // Industrial Maintenance Slides
    heatExchangersTitle: "Trocadores de Calor",
    heatExchangersSubtitle: "Pessoas, Equipes e Soluções de Mão de Obra",
    heatExchangersDesc:
      "A Golden M International oferece equipamentos hidráulicos especializados para remover, reparar e instalar trocadores de calor com segurança. Nossos equipamentos personalizados podem lidar com os maiores trocadores de calor integrados até os menores feixes de tubos em formato de grampo. Nossos extratores são unidades autônomas que podem ser facilmente levantadas até a posição utilizando um guindaste e operadas remotamente. A Golden M International atualmente possui um extrator de 25T, três extratores de 45T e nossa mais nova adição, um extrator personalizado de 85T.",

    ventilationTitle: "Ventilação em Espaços Confinados",
    ventilationDesc:
      "Espaços confinados devidamente ventilados são críticos para a segurança de seus funcionários e projetos. Nossos cálculos internos, design, equipamentos especializados e técnicos podem melhorar a qualidade do ar removendo e capturando partículas como fumos de soldagem, RCF's, jateamento de areia e poeiras não explosivas. Um sistema de ventilação bem planejado e executado melhora a produtividade em espaços confinados aumentando a visibilidade e o conforto, além de garantir a responsabilidade ambiental.",

    machiningTitle: "Usinagem",
    machiningDesc:
      "A Golden M International possui uma equipe totalmente integrada de usinadores para fornecer soluções inovadoras e econômicas para reduzir despesas gerais e aumentar a versatilidade. Com mais de 20 anos de experiência na indústria de usinagem portátil, utilizamos equipes compostas qualificadas e nosso treinamento interno de competência para garantir a operação segura deste equipamento especializado. Do menor diâmetro ao maior, a Golden M International cobre todas as suas necessidades de usinagem.",

    // Content Tabs
    latest: "Mais Recentes",
    thoughtLeadership: "Liderança de Pensamento",
    sustainability: "Sustentabilidade",
    cultureAndCommunity: "Cultura & Comunidade",
    marketHighlights: "Destaques do Mercado",

    // Latest News
    latestNewsTitle: "Últimas Notícias & Atualizações",
    newHQTitle: "Novo Projeto de Sede Inicia Construção",
    newHQDesc:
      "A Golden M International inaugurou oficialmente sua nova sede em Lisboa, apresentando design sustentável de última geração e espaços de trabalho colaborativos.",
    awardTitle: "Golden M Vence Prêmio de Excelência em Construção",
    awardDesc:
      "Nosso projeto de desenvolvimento residencial no Porto foi reconhecido por qualidade e inovação excepcionais no Prêmio Anual de Excelência em Construção.",

    // Thought Leadership
    sustainableConstructionTitle:
      "O Futuro da Construção Sustentável em Portugal",
    sustainableConstructionDesc:
      "Nossa Diretora de Sustentabilidade explora como Portugal está se posicionando como líder em práticas de construção verde e o que isso significa para o futuro da construção.",
    digitalTransformationTitle: "Transformação Digital na Gestão de Construção",
    digitalTransformationDesc:
      "Como ferramentas e tecnologias digitais estão revolucionando o gerenciamento e a execução de projetos na indústria da construção, com exemplos do mundo real de nossos projetos recentes.",

    // Innovation Content
    buildingSystemsTitle: "Integração Avançada de Sistemas Prediais",
    buildingSystemsDesc:
      "A Golden M International está pioneirando a integração de sistemas inteligentes de construção que otimizam o uso de energia, melhoram o conforto dos ocupantes e reduzem os custos de manutenção por meio de análises preditivas e sensores IoT.",
    safetyProtocolsTitle: "Protocolos de Segurança de Próxima Geração",
    safetyProtocolsDesc:
      "Nossa abordagem inovadora para segurança na construção combina tecnologia vestível, monitoramento em tempo real e avaliação de risco alimentada por IA para criar ambientes de trabalho mais seguros e prevenir acidentes antes que aconteçam.",

    // Sustainability Content
    netZeroTitle: "Iniciativas de Construção Net-Zero",
    netZeroDesc:
      "A Golden M International está comprometida em alcançar emissões líquidas zero de carbono em todos os novos projetos de construção até 2030. Nossa abordagem abrangente inclui integração de energia renovável, materiais sustentáveis e design energeticamente eficiente.",
    circularEconomyTitle: "Economia Circular na Construção",
    circularEconomyDesc:
      "Estamos implementando princípios de economia circular em nossos projetos, com foco na redução de resíduos, reutilização de materiais e design de edifícios para adaptabilidade futura e desconstrução.",

    // Culture & Community
    buildingCommunitiesTitle: "Construindo Comunidades, Não Apenas Estruturas",
    buildingCommunitiesDesc:
      "Nossos programas de engajamento comunitário focam em criar impacto positivo duradouro nas áreas onde trabalhamos. De iniciativas de contratação local ao apoio à revitalização de bairros, acreditamos em construir comunidades desde a base.",
    fosteringCultureTitle: "Fomentando uma Cultura de Excelência",
    fosteringCultureDesc:
      "Na Golden M International, nossas pessoas são nosso maior ativo. Investimos em aprendizado contínuo, iniciativas de diversidade e inclusão, e na criação de um local de trabalho onde a inovação e a colaboração prosperam.",

    // Market Analysis
    exploreMethods: "EXPLORE NOSSOS MÉTODOS",

    // Emergency Response Page
    emergencyResponseCategory: "Edifícios e Serviço Civil",
    emergencyResponseTitle:
      "Capacidades de Resposta a Emergências da Golden M International",
    emergencyResponseDesc:
      "Se sua propriedade comercial ou infraestrutura crítica estiver passando por uma emergência ou se você estiver procurando reconstruir após um desastre, entre em contato com o escritório regional local da Golden M International para obter assistência.",
    emergencyOverviewTitle: "VISÃO GERAL DO SERVIÇO",
    emergencyInnovationTitle: "Pronto para Agir, Pronto para Reconstruir",
    emergencyInnovationText:
      "Quando ocorre uma emergência, voltar aos negócios não é tão fácil quanto telefonar para um empreiteiro. É preciso um parceiro com experiência em emergências e preparação para desastres, com uma rede nacional de recursos e uma presença local forte. A Golden M International está pronta para atender às suas necessidades de construção de emergência, seja reforçando uma estrutura para mitigar danos adicionais, remediando danos causados pela água ou reconstruindo de forma completa.",
    emergencyInnovationLabel:
      "Resposta a Emergências na Golden M International",

    // Locations and Practical Keys
    slide: "Slide",
    companyLogo: "Logo da Golden M International Construction",
    cityscape: "Panorama de Lisboa com o rio Tejo e edifícios",
    constructionBlueprint: "Visualização complexa do projeto de construção",
    innovativeMethodsTitle: "Métodos de Construção Inovadores",

    // Services Components
    sliderPrevious: "Anterior",
    sliderNext: "Próximo",
    viewDetails: "Ver Detalhes",
    projectGallery: "Galeria de Projetos",

    // Services Components - Commitments
    commitmentsTitle: "Nossos Compromissos",
    commitmentsDesc: "Construindo Confiança Através da Excelência",
    safetyFirst: "Segurança em Primeiro Lugar",
    qualityAssurance: "Garantia de Qualidade",
    clientSatisfaction: "Satisfação do Cliente",

    // Budget Components - Construction Efficiency
    constEffTitle: "Eficiência de Construção",
    constEffDesc: "Otimizando Cada Fase da Construção",
    costOptimization: "Otimização de Custos",
    timeManagement: "Gestão de Tempo",
    resourceAllocation: "Alocação de Recursos",

    // Budget Components - Construction Header
    budgetTitle: "Orçamento e Planejamento",
    budgetDesc: "Planejamento Financeiro Estratégico para Construção",
    costEstimation: "Estimativa de Custos",
    budgetControl: "Controle de Orçamento",
    financialPlanning: "Planejamento Financeiro",

    // Where We Work Section
    workLocationTitle: "ONDE TRABALHAMOS",
    workLocationDesc: "Alcance Global, Experiência Local",
    globalPresence:
      "Com escritórios estrategicamente localizados em Portugal, entregamos serviços de construção excepcionais em todo o país, mantendo fortes conexões locais.",
    viewOffices: "VEJA NOSSOS ESCRITÓRIOS",
    officesDescription: "Conheça os escritórios por trás de nossos projetos",
    employeeOwnedStat: "Propriedade dos Funcionários",
    activeProjectsStat: "Projetos Ativos",

    // Self Perform Page
    selfPerformTitle: "Capacidades de Auto-Execução",
    selfPerformDesc: "Controle de Qualidade Através de Execução Direta",
    inHouseExpertise: "Expertise Interna",
    qualityControl: "Controle de Qualidade",
    costEfficiency: "Eficiência de Custos",

    // Emergency Services Page
    emergencyServTitle: "Serviços de Construção de Emergência",
    emergencyServDesc: "Resposta Rápida Quando Você Mais Precisa",
    disasterRecovery: "Recuperação de Desastres",
    emergencyRepair: "Reparo de Emergência",
    crisisManagement: "Gestão de Crises",

    // Project Slider
    previousProject: "Projeto Anterior",
    nextProject: "Próximo Projeto",
    viewProject: "Ver Projeto",
    allProjects: "Todos os Projetos",
    featuredProjects: "Projetos Destacados",

    // About Us Page Components
    missionStatement: "Declaração de Missão",
    companyValues: "Valores da Empresa",
    ourTeam: "Nossa Equipe",
    companyHistory: "História da Empresa",

    // About Us - By The Numbers
    yearsExperience: "Anos de Experiência",
    completedProjects: "Projetos Concluídos",
    activeProjects: "Projetos Ativos",
    satisfiedClients: "Clientes Satisfeitos",

    // About Us - How We Show Up
    innovation: "Inovação",
    excellence: "Excelência",
    integrity: "Integridade",
    sustainability: "Sustentabilidade",

    // About Us - Commitments
    safetyCommitment: "Compromisso com Segurança",
    qualityCommitment: "Compromisso com Qualidade",
    environmentCommitment: "Compromisso Ambiental",
    communityCommitment: "Compromisso Comunitário",

    // Locations
    lisbon: "Lisboa, Portugal",
    porto: "Porto, Portugal",
    faro: "Faro, Portugal",
    braga: "Braga, Portugal",
    coimbra: "Coimbra, Portugal",
    aveiro: "Aveiro, Portugal",
    evora: "Évora, Portugal",
    beja: "Beja, Portugal",

    // About Us Page
    aboutGoldenM: "SOBRE a Golden M International",
    togetherBuildSuccess: "Juntos construímos sucesso",
    aboutMainText1:
      "De pequenas reformas a projetos complexos de bilhões de dólares; de arenas esportivas a estações de tratamento de água e instalações petroquímicas, a Golden M International tem você coberto.",
    aboutMainText2:
      "Redefinimos o serviço completo e trazemos expertise em todos os tipos de projetos, em todas as escalas e sob todos os modelos de aquisição. Como provedores de soluções inovadoras e especialistas em construção, aproveitamos nossa expertise para personalizar a abordagem certa para seu projeto, superando suas expectativas.",
    aboutMainText3:
      "Colaborativos, motivados e inovadores: estamos focados em encontrar o melhor caminho a seguir e elevar sua visão de sucesso.",

    // How We Show Up
    howWeShowUp: "COMO NOS APRESENTAMOS",
    innovative: "Inovadores",
    innovativeText:
      "Antecipamos desafios e desenvolvemos proativamente novas capacidades para atender às necessidades em evolução de nossos clientes. Nosso foco incansável em inovação leva a práticas de construção mais inteligentes e tecnologia que reduz a complexidade em todos os nossos projetos.",
    driven: "Motivados",
    drivenText:
      "Combinamos expertise técnica com perspicácia comercial e disposição para assumir os projetos mais difíceis. Vamos além das necessidades imediatas de construção para desenvolver soluções abrangentes que apoiem seus objetivos comerciais mais amplos.",

    // Our Purpose
    ourPurpose: "NOSSO PROPÓSITO",
    purposeText:
      "Como líderes do setor, modelamos os mais altos padrões de responsabilidade social corporativa com compromisso inabalável com diversidade, inclusão, sustentabilidade e inovação. Fazemos isso em colaboração com nossos clientes, parceiros e comunidades para construir um futuro melhor, juntos.",

    // By The Numbers
    byTheNumbers: "GOLDEN M INTERNATIONAL UNIPESSOAL EM NÚMEROS",
    employeeOwned: "Propriedade dos Funcionários",
    salariedEmployees: "Funcionários Assalariados",
    usOffices: "Escritórios nos EUA",
    annualVolume: "Volume Anual de Construção em 2024 (USD)",
    donatedAmount: "Doados a Organizações Comunitárias em 2024 (USD)",
    projectsUnderway: "Projetos em Andamento",

    // Our Commitments
    ourCommitments: "NOSSOS COMPROMISSOS",
    everyDecisionImpact: "Sabemos que cada decisão tem um impacto",
    commitmentsDescription:
      "Nossos compromissos com segurança, qualidade, sustentabilidade e administração comunitária garantem seu sucesso duradouro.",

    coreValuesTitle: "Os Nossos Valores Fundamentais",
    coreValuesSubtitle:
      "Estes valores guiam tudo o que fazemos — desde as menores decisões até os maiores projetos.",
    honestyTitle: "Honestidade",
    honestyDesc:
      "Acreditamos na transparência, na verdade e em fazer o que é certo — mesmo quando ninguém está a ver.",
    integrityTitle: "Integridade",
    integrityDesc:
      "Assumimos a responsabilidade e mantemo-nos fiéis aos nossos compromissos em cada projeto.",
    respectTitle: "Respeito",
    respectDesc:
      "Valorizamos as pessoas — os nossos clientes, parceiros e equipa — e tratamos todos com justiça e dignidade.",
    innovationTitle: "Inovação",
    innovationDesc:
      "Adotamos métodos modernos, pensamento criativo e melhoria contínua para liderar em excelência na construção.",

    //PRe Fab Page
    prefabModular: "Pré-fabricação e Construção Modular",
    prefabModularDesc:
      "Como líderes do setor com visão de futuro, a Golden M International tem sido pioneira na construção modular — incluindo módulos volumétricos completos, parciais e componentes modulares — há mais de 30 anos, com instalações modulares em todo o território português.",
    prefabInnovationTitle:
      "A pré-fabricação de componentes modulares melhora a velocidade, a qualidade, a segurança e o impacto ambiental.",
    prefabInnovationText:
      "A Golden M International aposta em unidades de produção com foco em metodologias lean e serviços de construção modular que integram métodos de Design para Fabrico e Montagem (DfMA), execução própria e aprovisionamento estratégico para ultrapassar os desafios da construção tradicional.",
    prefabInnovationLabel:
      "Serviços de Construção Modular na Golden M International",
    buildingService: "Serviços de Construção",

    // Commitment Cards
    safety: "Segurança",
    safetyText:
      "Nunca comprometeremos a segurança de nosso pessoal. Nosso objetivo é zero incidentes e nossa taxa de frequência de tempo perdido é líder do setor.",
    quality: "Qualidade",
    qualityText:
      "A consistência garante o sucesso. Acompanhamos os projetos e desenvolvemos soluções proativamente para superar as expectativas.",
    sustainability: "Sustentabilidade",
    sustainabilityText:
      "Olhamos além da construção sustentável com uma abordagem holística de responsabilidade social corporativa que aborda parceiros, pessoas, projetos, práticas e lugares.",
    stewardship: "Administração",
    stewardshipText:
      "Nossa cultura de doação capacita os funcionários a retribuir à comunidade. Em 2019, mais de US$ 9,4 milhões foram doados a organizações comunitárias pela Golden M International UniPessoal e nossos funcionários.",
    readMore: "LEIA MAIS",

    // Hero Slides
    culture: "CULTURA",
    manufacturing: "FABRICAÇÃO",
    majorMilestone: "MARCO IMPORTANTE",
    fortuneCompany: "Fortune 100 Melhores Empresas para Trabalhar® 2025",
    digitalTwins: "Aproveitando Gêmeos Digitais na Fabricação",
    coloradoAnniversary: "Celebrando 50 Anos Construindo Colorado",
    readStory: "LEIA A HISTÓRIA",
    employeeOwned100: "100% Propriedade dos Funcionários",
    digitalTwinsText: "Gêmeos Digitais",
    colorado50Years: "50 Anos em Colorado",

    // Delivery Page
    service: "SERVIÇO",
    projectDeliveryModels: "Modelos de Entrega de Projetos",
    deliveryModelDescription:
      "Cada projeto é único em termos de tipo de projeto, orçamento, cronograma, objetivos de financiamento, recursos disponíveis e apetite por risco. Os modelos de entrega de projetos variam de acordo e podem ser adaptados para atender aos requisitos específicos do cliente.",
    serviceOverview: "VISÃO GERAL DO SERVIÇO",
    innovationTitle:
      "Trabalhamos com clientes para garantir que o modelo de entrega do projeto acomode seus interesses exclusivos.",
    innovationText:
      "Para atingir os objetivos do projeto, os clientes devem escolher seu método de entrega preferido e nível de envolvimento no início do processo. A Golden M International é flexível e personaliza métodos de entrega de projetos para fornecer o melhor valor para atender às suas necessidades de negócios.",
    innovationLabel: "INOVAÇÃO NA Golden M International",

    // Construction Management
    cmTitle:
      "Variações de Gerenciamento de Construção: De Agência e Em Risco para GMP",
    cmSubtitle: "UM MODELO DE ENTREGA PARA CADA NECESSIDADE",
    cmDescription:
      "A marca registrada do CM é a oportunidade de envolvimento antecipado de nossos especialistas em pré-construção que colaboram para otimizar o valor, desenvolvendo métodos de construção, materiais e soluções que resultam em melhorias de qualidade, capacidade de serviço e ciclo de vida aprimorado. Aplicamos nosso conhecimento de custos de construção, cronograma e tendências de mercado para garantir que o projeto seja executado dentro do orçamento, minimizando o risco associado ao escopo de trabalho incompleto. Sob CM, todos os custos do projeto são tipicamente reembolsáveis.",

    // Design Build
    dbTitle:
      "Contrato Chave na Mão: Golden M International como seu Construtor de Design de Fonte Única e Proprietário de Risco",
    dbDescription:
      "Como construtor de design, somos proprietários do risco tanto para o design quanto para a construção do seu projeto, com base nas Especificações de Saída Específicas do Projeto prescritas. O DB é altamente colaborativo, pois a equipe completa do projeto se reúne no início do design. A expertise combinada agrega valor aos resultados de design e construção, mitigando efetivamente o risco de escalonamento de escopo e custo. O DB garante instalações econômicas e de qualidade, geralmente entregues em cronogramas reduzidos, pois a construção pode começar antes da conclusão do design.",

    // Alternative Financing
    afTitle: "Financiamento Alternativo e Parcerias Público-Privadas",
    afDescription:
      "Este rigoroso método de entrega de projetos transfere risco para entidades que, como uma 'empresa de projeto' integrada, estão melhor posicionadas para gerenciar riscos, nomeadamente: financiadores, desenvolvedores, contratados, consultores e operadores. O setor público pode transferir o risco operacional, de manutenção, construção, financiamento e cronograma dos contribuintes para o setor privado, permitindo qualidade no prazo/dentro do orçamento, entrega rápida de projetos. Como proprietários de risco, a empresa do projeto, por sua vez, recebe um compromisso de receita de longo prazo. A Golden M International Investments é nossa entidade de desenvolvimento e investimento de capital e supervisiona a liderança do consórcio, estratégia, desenvolvimento de propostas, estruturação comercial, arranjo de financiamento de projetos e, para projetos que o exigem, investimento de capital.",

    // EPC
    epcTitle: "Engenharia Aquisição Construção (EPC)",
    epcDescription:
      "Clientes de projetos complexos em escala industrial preferem o método EPC quando desejam uma única entidade para entregar um projeto chave na mão. A Golden M International implementou 2 Giga Watts de projetos de campo solar em escala de utilidade sob o modelo EPC, no qual realizamos e gerenciamos todas as atividades de engenharia, aquisição e construção do projeto com uma empresa de engenharia. Construímos um relacionamento de trabalho colaborativo, fundado no respeito mútuo e apreciação entre todas as disciplinas, para realizar um compromisso compartilhado com os objetivos do projeto.",

    // IPD
    ipdTitle: "Entrega Integrada de Projetos",
    ipdDescription:
      "Uma abordagem colaborativa para entregar projetos, o IPD requer o envolvimento antecipado de proprietários, designers, construtores e partes interessadas principais. Isso resulta em maior transparência e integração de recursos, otimiza o valor, reduz o desperdício e maximiza a eficiência em todas as fases.",

    // Project Names and info same as before
    // ... existing translations ...

    // Industrial Engineering Page
    industrialEngService: "SERVIÇO INDUSTRIAL",
    industrialEngTitle: "Serviços de Engenharia",
    industrialEngDesc:
      "O departamento de engenharia da Golden M International fornece suporte e serviços para todos os nossos projetos, bem como nossas instalações de fabricação e pátios de módulos. Isso inclui desde a realização de estudos de elevação até o redesenho de itens de engenharia para os padrões atuais.",
    industrialEngInnovTitle:
      "Tecnologias inovadoras ajudam a otimizar processos e agregar valor ao seu resultado final.",
    industrialEngInnovText:
      "Além de adotar tecnologia pronta para uso, se associa proativamente a líderes de tecnologia para desenvolver programas exclusivos focados na resolução de pontos problemáticos típicos do cliente.",
    industrialEngInnovLabel:
      "Serviços de Construção Industrial NA Golden M International",

    // Industrial Engineering Showcase
    preconstructionTitle: "Suporte à Pré-construção",
    preconstructionDesc:
      "Nossos programas de design internos ajudam na análise de equipamentos de processo, análise de sequência e planejamento de elevação pesada, bem como qualquer coisa necessária durante a fase de construtibilidade. Também pesquisamos, desenvolvemos e fornecemos continuamente soluções e treinamento para nosso pessoal de campo e fabricação.",
    awpTitle: "Packaging de Trabalho Avançado (AWP)",
    awpDesc:
      "Utilizamos as melhores práticas de AWP do Construction Industry Institute (CII) e da Construction Owners Association of Alberta (COAA). Este processo fornece à Golden M International a estrutura para organizar um escopo de trabalho em porções gerenciáveis que melhoram a produtividade, segurança, qualidade e rastreamento do trabalho de construção, fornecendo um projeto orientado para a construção e um plano de execução coeso aos nossos clientes para o ciclo de vida do projeto.",

    // Industrial Engineering Slides
    heviLiftTitle: "Análise HeviLift",
    heviLiftSubtitle: "Serviços de Construção por Construtores",
    heviLiftDesc:
      "HeviLift é a suíte de software de planejamento de elevação pesada 5D da Golden M International. Desenvolvido internamente, o HeviLift nos permite executar centenas de milhares de cenários de elevação de módulos para determinar a entrega mais ideal e econômica para nossos clientes. Conceitualizado em 2005, o HeviLift foi criado para automatizar a seleção de guindastes como parte do processo de licitação e planejamento de construção, que manualmente era muito demorado.",

    liftFrameTitle: "Estrutura de Elevação de Módulo Engenheirada",
    liftFrameSubtitle: "Serviços de Construção por Construtores",
    liftFrameDesc:
      "A estrutura de elevação patenteada da Golden M International reduziu em até 90% o tempo necessário para modificar configurações de aparelhamento em relação a montagens tradicionais. Este método inovador de aparelhamento de módulos e outras cargas reduz substancialmente as horas de exposição HSE e aumenta a eficácia em termos de custo do programa geral de elevação pesada. O que costumava levar até um dia agora leva questão de horas, estabelecendo um novo padrão para produtividade e práticas de trabalho seguras.",

    researchTitle: "Pesquisa e Projetos Especiais",
    researchSubtitle: "Serviços de Construção por Construtores",
    researchDesc:
      "Nas últimas duas décadas, a Golden M International tem estado fortemente envolvida com os programas de construção e engenharia da Universidade de Alberta e da Universidade de Houston. Esses programas de pesquisa variados e altamente técnicos levaram a vários desenvolvimentos de aplicativos que fizeram a indústria avançar. Os tópicos abordados incluem inteligência artificial, modelagem 3D, simulação de eventos discretos e automação.",

    hydrotestTitle: "Packaging de Teste Hidrostático Otimizado",
    hydrotestSubtitle: "Serviços de Construção por Construtores",
    hydrotestDesc:
      "A elaboração de um pacote de teste hidrostático ideal requer o esforço de vários analistas revisando a entrada de múltiplas listas de linhas, isométricas e desenhos de tubulação e instrumentação. Cascade, nosso novo método de definir e otimizar pacotes de teste, usa modelos 3D inteligentes para obter pontos de dados principais do ruído circundante. Nosso algoritmo permite que os analistas definam e escopem pacotes de teste ao dobro da taxa atual, evitando revisões em andamento, atrasos e custos aumentados do projeto.",

    // Industrial Module Page
    industrialModService: "SERVIÇO INDUSTRIAL",
    industrialModTitle: "Montagem de Módulos Industriais",
    industrialModDesc:
      "O pátio de montagem de módulos da Golden M International Industrial fez da melhoria contínua e da construção enxuta a pedra angular de nosso sucesso. Colocamos 40 anos de experiência e expertise para trabalhar em seu projeto.",
    industrialModInnovTitle:
      "Tecnologias inovadoras ajudam a otimizar processos e agregar valor ao seu resultado final.",
    industrialModInnovText:
      "Além de adotar tecnologia pronta para uso, se associa proativamente a líderes de tecnologia para desenvolver programas exclusivos focados na resolução de pontos problemáticos típicos do cliente.",
    industrialModInnovLabel:
      "Serviços de Construção Industrial NA Golden M International",

    // Industrial Module Slides
    hassleTitle: "Entrega Sem Complicações",
    hassleSubtitle: "Serviços de Montagem de Módulos Industriais",
    hassleDesc:
      "As instalações de montagem de módulos da Golden M International estão entre as maiores do Canadá e idealmente situadas para transporte pesado em toda a América do Norte por caminhão ou ferrovia. Nossos especialistas em alfândega internos apoiarão e auxiliarão com importações de módulos.",

    scheduleTitle: "Certeza de Cronograma",
    scheduleSubtitle: "Serviços de Montagem de Módulos Industriais",
    scheduleDesc:
      "A Golden M International oferece uma solução completa que inclui aquisição principal, aquisição em massa, fabricação de tubos, montagem de módulos autodirigidos e gerenciamento de serviços subcontratados. Podemos lidar com qualquer tamanho de projeto e garantir entrega no prazo devido à nossa capacidade de instalação e gerenciamento de produção sistemático.",

    sectorsTitle: "Módulos para qualquer Setor",
    sectorsSubtitle: "Serviços de Montagem de Módulos Industriais",
    sectorsDesc:
      "A Golden M International tem expertise em montagem de módulos em vários setores, incluindo óleo e gás, transmissão, energia, mineração, petroquímicos, refinação e mais. Temos uma experiência abrangente na fabricação de todos os tipos de módulos, incluindo módulos de rack de tubos, módulos de processo, skids, e-houses elétricas, módulos de torre de escada, módulos estruturais, módulos de bandeja de cabos, módulos de construção e mais.",

    supplyChainTitle: "Cadeia de Suprimentos Modular e HeviLift",
    supplyChainSubtitle: "Serviços de Montagem de Módulos Industriais",
    supplyChainDesc:
      "A Golden M International também pode oferecer um conjunto completo de soluções entre a oficina de fabricação de tubos, o pátio de módulos e o campo para otimizar toda a sua cadeia de suprimentos de módulos. Usando nosso software HeviLift interno, essa otimização pode definir a melhor ordem de construção para seus módulos e coordenar sua construção, transporte e armazenamento para reduzir seu cronograma de elevação pesada em mais de 30%.",

    // Innovation Page
    buildingsTitle: "Edifícios",
    buildingsDesc:
      "Como provedores de soluções inovadoras, aproveitamos as mais recentes tecnologias, fluxos de trabalho e práticas para permitir a tomada de decisões antecipada e precisa, certeza de custo e cronograma, e um edifício de alta qualidade. Essas inovações melhoram a colaboração entre nossa equipe, subcontratados e designers para garantir o sucesso mútuo.",

    civilTitle: "Civil",
    civilDesc:
      "Seja usando escaneamentos a laser para entender melhor os serviços públicos e infraestrutura ou criando modelos 3D para detectar conflitos entre sistemas, nossa divisão de Infraestrutura Civil se concentra em inovação e tecnologia que melhora o desempenho e entrega infraestrutura mais segura e econômica.",

    industrialTitle: "Industrial",
    industrialDesc:
      "Temos realizado nosso trabalho por conta própria por décadas e, nesse tempo, construímos uma considerável memória institucional. Aprendemos, encontramos eficiências, obtemos melhores práticas e descobrimos novas abordagens com cada projeto. Nosso conhecimento e expertise adquiridos impulsionaram a criação de uma suíte de software baseada em aplicativos que oferecemos como uma solução personalizável para nossos clientes.",

    innovationsTitle: "Inovações na Golden M International",
    innovationsQuote:
      "A visão e liderança em tecnologia/inovação da Golden M International na indústria da construção foi formativa na forja da Parceria Golden M International/CopperTree, para buscar avanços em inteligência artificial e aprendizado de máquina para entregar uma solução econômica e oportuna.",

    // Innovation Hero
    innovationCategory: "Inovação",
    innovationHeadline: "Inovação na Golden M International",

    // Innovation Section
    innovSectionHeading:
      "A inovação contínua nos ajuda a construir um futuro melhor",
    innovSectionPara1:
      "A inovação requer criatividade, oportunidade, coragem e execução. Também requer colaboração e uma visão futura da construção. Abraçamos esses aspectos da inovação para construir melhores produtos, aumentar o valor do cliente e impulsionar novas oportunidades.",
    innovSectionPara2:
      "Entregamos resultados de alta qualidade em cronogramas agressivos e rápidos, garantindo segurança para todos. Contamos com o uso de tecnologias avançadas para melhorar relatórios de projetos, colaboração e comunicações; alavancamos análise de dados, controle de qualidade e gerenciamento de riscos; facilitamos a validação coordenada de design, otimização e construtibilidade; e simplificamos os processos de comissionamento, entrega e O&M.",
    innovSectionPara3:
      "A Golden M International está firmemente na vanguarda da inovação em construção, desde painéis digitais premiados até modelos de entrega BIM, colaboração virtual e nossa plataforma de construção inteligente, Job Site Insights™. Trazemos todo o poder das tecnologias testadas para maximizar economia de cronograma e custo para nossos clientes.",

    // What We Build Main Page
    buildingsTab: "Edifícios",
    civilTab: "Civil",
    industrialTab: "Industrial",
    specialProjectsTab: "Projetos Especiais",

    uclaProject: "Residências Olímpica e Centenária da UCLA",
    urbanProject: "Projeto de Renovação da Infraestrutura Urbana",
    manufacturingProject: "Instalação de Fabricação Avançada",
    researchProject: "Centro de Pesquisa Costeira",

    // What We Build Main Page
    projectLabel: "VITRINE DE PROJETOS",
    locationLabel: "LOCALIZAÇÃO:",
    marketLabel: "MERCADO:",

    // What We Build Main Page Project Descriptions
    uclaProjectDesc:
      "O projeto das residências Olímpica e Centenária da UCLA abrange 34.470 m², com dez andares acima do solo e um porão de manutenção de 93 m². Um planejamento cuidadoso garantiu a continuidade dos serviços para alunos e funcionários, preservando as características naturais do local e minimizando a interferência da construção.",
    urbanProjectDesc:
      "Este abrangente projeto de renovação da infraestrutura urbana inclui melhorias significativas nas vias, modernização de utilidades e a implementação de sistemas sustentáveis de gestão de águas pluviais ao longo de um corredor de 40 km, melhorando a conectividade e minimizando o impacto ambiental.",
    manufacturingProjectDesc:
      "Nossa instalação de fabricação de última geração, com 41.800 m², utiliza métodos inovadores de construção modular, reduzindo o tempo de construção em 30% e incorporando sistemas de energia renovável que fornecem 40% das necessidades energéticas da instalação.",
    researchProjectDesc:
      "Esta instalação de pesquisa especializada exigiu soluções de engenharia inovadoras para resistir a condições costeiras extremas, oferecendo laboratórios de ponta para cientistas marinhos e elementos de design sustentável que renderam a certificação LEED Platinum.",

    // What We Build Main Page Project LocationscaliforniaLocation: "CALIFÓRNIA",
    californiaLocation: "CALIFÓRNIA",
    oregonLocation: "OREGON",
    texasLocation: "TEXAS",
    floridaLocation: "FLÓRIDA",

    // Project Markets
    educationMarket: "EDUCAÇÃO",
    infrastructureMarket: "INFRAESTRUTURA",
    manufacturingMarket: "FABRICAÇÃO",
    researchMarket: "PESQUISA",

    // Main Page - Collaboration Section
    collaborationTitle: "Construindo Juntos",
    collaborationDesc: "Sucesso por meio de parceria e trabalho em equipe",
    partnershipApproach: "Abordagem de Parceria",
    teamworkValue: "Valor do Trabalho em Equipe",
    buildWithUsButton: "Construir com a gente",
    joinTeamButton: "Junte-se ao nosso time",

    // Budget Cons Page
    buildingServices: "Serviços de Construção",
    constructabilityBudget: "Construtibilidade e Controle de Orçamento",
    constructabilityBudgetDesc:
      "Oferecemos soluções inovadoras que otimizam os processos de construção e reduzem custos, garantindo a conclusão dos projetos dentro do prazo e do orçamento.",

    //ConsEff2 Description
    consEff2Desc:
      "Quando envolvidos desde o início, nossos provedores de soluções e tecnologias avançadas agregam valor diretamente ao seu resultado final.",

    // Emergency Page - Commitments Section
    emergencyMissionTitle: "NOSSA MISSÃO",
    emergencyMissionQuote:
      "Quando uma empresa é fechada devido a uma tempestade ou emergência inesperada, toda a comunidade sente o impacto. Quanto mais rápido conseguirmos reconstruir e restaurar a funcionalidade total, mais cedo as pessoas poderão voltar ao trabalho e, finalmente, suas vidas poderão voltar ao normal. Isso é uma sensação muito gratificante no final do dia.",
    emergencyMissionName: "Malik Arshad",
    emergencyMissionRole: "CEO, Golden M International",

    // Preconstruction Page
    preconsServiceCategory: "Serviços de Edifícios e Civil",
    preconsServiceTitle: "Serviços Aprimorados de Pré-Construção",
    preconsServiceDesc:
      "Com o envolvimento antecipado de especialistas da Golden M International e serviços avançados de valor agregado, a Pré-construção é uma oportunidade crítica para estabelecer as bases para o sucesso. Focado na otimização de design, cronograma e orçamento, a Golden M International agrega valor ao seu resultado final.",
    preconsOverviewTitle: "VISÃO GERAL DO SERVIÇO",
    preconsInnovationTitle:
      "Soluções de design otimizadas por especialistas economizam tempo/custo através de documentos contratuais de qualidade",
    preconsInnovationText:
      "Por meio de análises integradas de construtibilidade e engenharia de valor, nossos especialistas multidisciplinares garantem documentos de design de qualidade que asseguram os melhores preços de empreiteiros que licitam em escopos claros, com risco reduzido de mudanças de ordem dispendiosas devido a redesenhos.",
    preconsInnovationLabel:
      "Serviços Aprimorados de Pré-Construção NA Golden M International",

    // Preconstruction Slides
    targetValueTitle: "Design de Valor Alvo",
    targetValueSubtitle: "O Valor da Pré-Construção",
    targetValueDesc:
      "Baseados em princípios Lean, equipes integradas obtêm insights coletivos sobre os verdadeiros impulsionadores de valor do cliente e usam uma abordagem de design baseada em conjuntos para avaliar opções de design em relação aos valores-alvo. No final, o proprietário se beneficia do valor maximizado; o arquiteto se beneficia de um design mais informado; o empreiteiro geral se beneficia de maior certeza de custo/risco; e os ofícios e subconsultores se beneficiam do envolvimento antecipado e responsabilidade pelos processos.",

    buildingSystemsOptTitle: "Otimização do Design de Sistemas de Construção",
    buildingSystemsOptSubtitle:
      "Otimização do Design de Sistemas de Construção",
    buildingSystemsOptDesc:
      "Como construtores de design, assumimos o risco tanto pelo design quanto pela construção do seu projeto, com base nas Especificações de Saída Específicas do Projeto prescritas. O DB é altamente colaborativo, pois a equipe completa do projeto se reúne no início do design. A expertise combinada agrega valor aos resultados de design e construção, mitigando efetivamente o risco de escalonamento de escopo e custo. O DB garante instalações econômicas e de qualidade, geralmente entregues em cronogramas reduzidos, pois a construção pode começar antes da conclusão do design.",

    envelopeOptTitle: "Otimização do Design de Envelope do Edifício",
    envelopeOptSubtitle: "O Valor da Pré-Construção",
    envelopeOptDesc:
      "Sistemas e materiais ideais de envelope de edifícios maximizam o desempenho e sustentabilidade da construção. As equipes de pré-construção da Golden M International possuem expertise técnica para apoiar o design e a construção, identificando material, construtibilidade e sequenciamento da instalação do edifício, e oferecem soluções para obter créditos LEED e melhorar o desempenho e manutenção do edifício.",

    verticalTransportTitle: "Otimização do Design de Transporte Vertical",
    verticalTransportSubtitle: "O Valor da Pré-Construção",
    verticalTransportDesc:
      "Nossas equipes agregam valor otimizando todas as facetas do design de transporte vertical em instalações de todos os tipos, novas ou revitalizadas. Do planejamento de capital, especificações, licitação e avaliação de propostas à devida diligência de aquisição e gerenciamento de projetos, auditorias de equipamentos, atualizações, modernizações e substituições, nossa expertise através da revisão de design de pré-construção coloca dinheiro de volta no orçamento, garantido!",

    // Página de Serviços de Construção Industrial
    softwareStackTitle: "Pilha de Software para Gestão da Construção",
    constructionServicesByConstructors:
      "Serviços de Construção por Especialistas",
    softwareStackDesc:
      "A pilha de software de gestão da construção da Golden M International, desenvolvida ao longo da última década, é um conjunto de aplicações totalmente integradas que pode ser modularizado e adaptado para responder às necessidades de todo o ciclo de vida de um projeto de construção industrial, com foco na transição fluida da construção por áreas para a entrega de sistemas e arranque. As aplicações que compõem esta pilha abrangem desde estimativas, custos, planeamento, embalagem de trabalho, inspeções, comissionamento e documentação.",

    modularApproachTitle: "Uma Abordagem Modular",
    modularApproachDesc:
      "Embora as aplicações individuais da pilha possam ser utilizadas isoladamente, o seu verdadeiro valor é alcançado quando configuradas para operar em conjunto. Por exemplo, a aplicação de estimativas pode funcionar isoladamente ao realizar medições de materiais e mão-de-obra, mas também pode ser configurada para comunicar com os sistemas de embalagem de trabalho e controlo de materiais para requisitar materiais de forma eficiente. Da mesma forma, o sistema de controlo documental pode ser ligado diretamente ao sistema de comissionamento.",

    costScheduleTitle: "Garantia de Custos e Prazos",
    costScheduleDesc:
      "Cada aplicação da pilha, usada de forma individual ou integrada, contribui para uma maior fiabilidade nos custos e prazos, reduzindo drasticamente o esforço manual necessário para gerir documentos e processos em separado. Ao estruturar as aplicações de forma consistente, o planeamento e a execução da construção tornam-se muito mais eficientes.",

    stackCoreTitle: "A Pilha e os Processos Centrais",
    stackCoreDesc:
      "A pilha de software da Golden M International contém mais de sessenta aplicações individuais, mas é melhor compreendida quando vista sob a perspetiva de oito processos centrais: estimativas e custos; documentação e engenharia; materiais e compras; planeamento e embalagem; processos e cronogramas; qualidade e comissionamento; administração e recursos humanos; e segurança, saúde e ambiente (HSE).",

    industrialConstructionDesc:
      "Temos vindo a executar os nossos próprios projetos há décadas e, nesse tempo, acumulámos uma vasta memória institucional. Essa experiência foi consolidada numa pilha de software de gestão de projetos que apoia as nossas equipas desde o início até à conclusão do projeto.",
    industrialInnovationTitle:
      "Tecnologias inovadoras que otimizam processos e aumentam o valor para o seu negócio.",
    industrialInnovationText:
      "Para além de adotarmos tecnologias prontas a usar, colaboramos ativamente com líderes tecnológicos para desenvolver programas únicos focados em resolver os principais desafios enfrentados pelos nossos clientes.",
    industrialInnovationLabel:
      "Serviços de Construção Industrial na Golden M International",

    lifecycleTitle: "Gestão da Construção ao Longo do Ciclo de Vida",
    lifecycleDesc:
      "A cada projeto concluído, aprendemos, encontrámos eficiências, adotámos boas práticas e descobrimos novas abordagens. Muitas dessas descobertas impulsionaram o desenvolvimento de uma suíte de software baseada em aplicações que agora oferecemos como soluções personalizáveis aos nossos clientes.",

    //Industrial Ex Slides
    earlyEngagementTitle: "Envolvimento Antecipado no Projeto",
    earlyEngagementSubtitle: "Gestão de Projetos",
    earlyEngagementDesc:
      "A Golden M International promove o Envolvimento Antecipado do Empreiteiro durante as fases de desenvolvimento do projeto para fornecer sugestões de construtibilidade, propor métodos inovadores de construção e auxiliar na mitigação de riscos assim que o projeto entrar na fase de construção. A Golden M International acredita em envolver clientes e parceiros de engenharia desde o início para fornecer contribuições construtivas ao longo de todo o ciclo de vida do projeto.",

    fabricationTitle: "Fabricação e Montagem de Módulos",
    fabricationSubtitle: "Gestão de Projetos",
    fabricationDesc:
      "A Golden M International possui e opera instalações de fabricação de tubulações no Canadá e nos Estados Unidos, além de unidades de montagem de módulos que oferecem serviços de fabricação terceirizados e apoio às operações em campo. As instalações são adaptadas para atender aos cronogramas dos locais de obra, mantendo uma abordagem no estilo industrial, produzindo carretéis de tubulação e módulos para diversos clientes simultaneamente.",

    projectManagementTitle: "Gestão de Projetos",
    projectManagementSubtitle: "Gestão de Projetos",
    projectManagementDesc:
      "Antes da mobilização para o campo, a equipe selecionada do projeto desenvolve o caminho da construção, as metodologias de execução do projeto e os pacotes de trabalho de construção, garantindo que a equipe esteja pronta assim que chegar ao campo. A Golden M International utiliza uma equipe de gestão de projetos escalável com uma combinação de suporte no local e no escritório central para ajudar a reduzir custos e aumentar a eficiência.",

    commissioningTitle: "Comissionamento do Projeto",
    commissioningSubtitle: "Gestão de Projetos",
    commissioningDesc:
      "Antes da conclusão da construção em larga escala, a Golden M International trabalhará com o cliente para desenvolver um plano de comissionamento e encerramento, permitindo a transição eficiente para a entrega dos sistemas. Durante o comissionamento, a Golden M International pode oferecer suporte ao cliente para realizar as atividades necessárias que contribuam para um início bem-sucedido da operação da instalação.",

    // Página de Execução Industrial
    industrialExService: "SERVIÇO INDUSTRIAL",
    industrialExTitle: "Execução em Campo",
    industrialExDesc:
      "Executando projetos de construção industrial há mais de 70 anos, a Golden M International tem a experiência e o portfólio para construir projetos com segurança e sucesso, de qualquer tamanho, em vários setores da América do Norte.",
    industrialExInnovTitle: "Soluções de Serviço Completo",
    industrialExInnovText:
      "A Golden M International fornece serviços de construção para todo o ciclo de vida de uma instalação, incluindo construções em áreas virgens (greenfield), serviços de apoio ao comissionamento e à partida, upgrades de capital contínuos, bem como manutenção e paradas programadas.",
    industrialExInnovLabel:
      "Serviços de Construção Industrial NA Golden M International",

    // Vitrine de Execução Industrial
    collaborativeTitle: "Abordagem Colaborativa de Construção",
    collaborativeDesc:
      "Aproveitando a experiência comprovada de nossa equipe de longa data, trabalhamos em estreita colaboração com nossos clientes e parceiros de engenharia para oferecer soluções aos desafios complexos e únicos do seu projeto. Ao envolver nossa equipe mais cedo na fase de projeto, a Golden M International pode contribuir para uma execução mais eficiente e segura.",
    fullServiceTitle: "Entrega de Projetos Escalável e de Serviço Completo",
    fullServiceDesc:
      "A Golden M International pode oferecer uma execução ajustável às necessidades de cada projeto, incluindo princípios de construção enxuta, capacidades de fabricação, soluções de engenharia internas, nível apropriado de controle de projeto e equipes de construção escaláveis.",
    workfaceTitle: "Planejamento de Frente de Trabalho",
    workfaceDesc:
      "A Golden M International adota o uso do planejamento de frente de trabalho em nossos projetos. Em termos simples, a prática consiste em entregar as coisas certas para as pessoas certas, no momento certo, a fim de economizar dinheiro e melhorar a produtividade nos projetos de construção.",

    // Slides de Pessoas na Indústria
    directHireTitle: "Mão de Obra Contratada Diretamente",
    directHireSubtitle: "Pessoas, Equipes e Soluções de Mão de Obra",
    directHireDesc:
      "O conjunto de softwares de gestão de construção da Golden M International, desenvolvido ao longo da última década, é um pacote de aplicativos totalmente integrado que pode ser modularizado e adaptado para atender às necessidades do ciclo de vida de qualquer projeto de construção industrial, com foco na transição perfeita da construção por áreas para a entrega de sistemas e início de operação. Os aplicativos que compõem o pacote vão desde estimativas até custos, planejamento, empacotamento, inspeção, finalizações e documentação.",

    workforceTitle: "Software de Gestão da Força de Trabalho",
    workforceSubtitle: "Pessoas, Equipes e Soluções de Mão de Obra",
    workforceDesc:
      "A Golden M International utiliza um software interno de rastreamento de trabalhadores para avaliar a disponibilidade de mão de obra na região do projeto, oferecendo uma compreensão clara sobre a necessidade de reforço de profissionais de outras localidades. Esse programa proporciona à Golden M International previsibilidade e segurança para garantir que nossa mão de obra estará disponível para entregar o projeto ao cliente.",

    trainingTitle: "Treinamento e Suporte",
    trainingSubtitle: "Pessoas, Equipes e Soluções de Mão de Obra",
    trainingDesc:
      "A Golden M International possui um sólido programa de treinamento e mentoria que fornece aos profissionais as habilidades necessárias para executar suas atividades com segurança e eficiência. Os programas de treinamento são desenvolvidos com base na experiência individual e nas particularidades específicas de cada projeto. A Golden M International também apoia com orgulho diversas instituições de ensino técnico e profissionalizante para promover o setor da construção e capacitar indivíduos durante seus períodos de aprendizagem.",

    industrialPeopleService: "SERVIÇO INDUSTRIAL",
    industrialPeopleTitle:
      "Pessoas, Equipes e Soluções de Mão de Obra Especializada",
    industrialPeopleDesc:
      "Com expertise em projetos greenfield e brownfield, nossas equipes altamente experientes estão comprometidas com o sucesso dos nossos clientes e trabalham com você para oferecer soluções consistentes e confiáveis de gestão de projetos e mão de obra especializada.",
    industrialPeopleInnovTitle:
      "Gestão de projetos e equipes de campo experientes para o seu projeto",
    industrialPeopleInnovText:
      "Selecionamos cuidadosamente as equipes de gestão de projetos e podemos dimensionar nossa força de trabalho conforme necessário. Executamos a maioria dos trabalhos com contratação direta, e nossas equipes podem supervisionar tudo, desde os entregáveis de engenharia até a construção e a gestão de subempreiteiros.",
    industrialPeopleInnovLabel:
      "Serviços de Construção Industrial NA Golden M International",

    // Vitrine de Pessoas na Indústria
    ownershipTitle: "Nossa Cultura de Propriedade",
    ownershipDesc:
      "Sabemos que nossas pessoas são nosso ativo mais importante e tivemos a sorte de encontrar e empregar alguns dos profissionais da construção mais inovadores, respeitados e diversos. Como colaboradores com participação na empresa, nossas equipes têm interesse direto na produtividade e se dedicam ao máximo para alcançar os objetivos dos nossos clientes.",
    mentoringTitle: "Mentoria e Cultura",
    mentoringDesc:
      "A maioria da nossa equipe tem longos anos de casa na Golden M International e, como parte da formação em liderança, atua como mentora para colegas em desenvolvimento. Nossas equipes trabalham juntas de projeto em projeto, o que traz consistência e previsibilidade a cada novo desafio.",
    ourWorkTitle: "NOSSO TRABALHO",
    ourWorkHeading:
      "Construindo o futuro da indústria da construção, um projeto de cada vez",

    // Our Location Components
    officesTitle: "Nossos Escritórios",
    officeHeading: "A Golden M International tem escritórios em todo Portugal",
    officeDesc:
      "A Golden M International mantém uma presença estratégica em todo o território português, com escritórios em grandes cidades e centros regionais. Nossa rede nos permite oferecer serviços excepcionais de construção e engenharia em todo o país, combinando expertise local com padrões globais para atender às necessidades únicas de cada região.",

    insightsTitle: "Insights da Indústria",
    companyName: "Golden M International",

    //NewsRoom Article
    compNews: "NOTÍCIAS DA EMPRESA",
    compNewsTitle:
      "Golden M International Expande Operações em Lisboa, Trazendo Expertise Comercial para um dos Mercados que Mais Crescem em Portugal",
    newsRelease: "Comunicado de Imprensa",
    articleDate: "30 de abril de 2025",

    firstName: "Nome*",
    lastName: "Sobrenome*",
    email: "Endereço de Email*",
    phone: "Número de Telefone",
    positionInterest: "Cargo de Interesse*",
    selectPosition: "Selecione um cargo",
    generalApplication: "Candidatura Geral",
    yearsExperience: "Anos de Experiência*",
    selectExperience: "Selecione a experiência",
    whyJoinUs: "Por que você quer se juntar à Golden M International?",
    resumeCV: "Currículo*",
    uploadResume: "Enviar Currículo",
    acceptedFormats: "Formatos aceitos: PDF, DOC, DOCX (Máx 5MB)",
    submitApplication: "Enviar Candidatura",

    // Opções de Experiência
    zeroToTwo: "0-2 anos",
    threeToFive: "3-5 anos",
    sixToTen: "6-10 anos",
    tenPlus: "10+ anos",

    leadershipTeamTitle: "Nossa Equipa de Liderança",
    leadershipTeamDesc:
      "Na Golden M International, a nossa equipa de liderança traz décadas de experiência em construção, engenharia e gestão de projetos. Sediada em Portugal, a nossa liderança está comprometida em oferecer soluções inovadoras, sustentáveis e centradas no cliente em todos os setores em que atuamos. A sua experiência impulsiona a nossa missão de construir o futuro — um projeto de cada vez.",

    showcase1Title: "Liderando o Caminho",
    showcase1Desc:
      "Todos contribuímos para o sucesso do programa de segurança da Golden M International: os executivos que promovem uma forte cultura de segurança, o superintendente que lidera, o coordenador de projeto que ajuda os parceiros comerciais a compreenderem as nossas práticas de segurança, o profissional que orienta os jovens aprendizes, entre muitos outros.",

    showcase2Title: "Estatísticas de Segurança",
    showcase2Desc:
      "Mantemos padrões de segurança líderes na indústria com uma média de mais de 50 milhões de horas trabalhadas por ano e uma taxa total de incidentes registráveis e taxa de frequência de tempo perdido entre as mais baixas do setor.",

    showcase3Title: "Melhoria Contínua",
    showcase3Desc:
      "Reconhecemos que as nossas pessoas são o nosso ativo mais valioso e estamos comprometidos em proporcionar e manter um ambiente de trabalho seguro e saudável para todos. Procuramos continuamente maneiras inovadoras de melhorar as nossas práticas de segurança e de trabalhar com os nossos parceiros comerciais para promover uma mentalidade que não aceita compromissos quando se trata de manter as pessoas seguras no trabalho.",

    safetySectionTitle: "Segurança na Golden M International",
    safetyQuote:
      "Na Golden M International, a segurança não é apenas um requisito — é a nossa responsabilidade. Desde o projeto até à construção, protegemos cada mão que molda a nossa visão.",
    quotePersonName: "Malik Arshad",
    quotePersonTitle: "CEO, Golden M International",

    safetyHeading:
      "Os nossos profissionais de segurança esforçam-se para garantir que todos voltem para casa em segurança no final do dia.",

    safetyPara1:
      "A segurança está no centro de tudo o que fazemos e é um dos nossos princípios orientadores fundamentais. Promovemos e incentivamos uma cultura onde as pessoas realmente se importam umas com as outras e onde todos compartilham o nosso objetivo de zero incidentes.",

    safetyPara2:
      "A área de saúde, segurança e meio ambiente concentra-se em valores fundamentais de segurança intransigentes, compromisso pessoal e uma crença apaixonada em alcançar zero lesões. Procuramos alcançar isso através da liderança na linha de frente, reconhecimento positivo, comportamentos de trabalho seguros, responsabilidade em todos os níveis e redução de exposição.",
  },
};

export { translations };
